
Object.defineProperty(self, "Q", {
    value: function (s, con) {
        if (typeof con === "string") con = document.querySelector(con);
        return s.indexOf("#") < 0 ? (con || document).querySelectorAll(s) : (con || document).querySelector(s);
        // !!! BAC >>>    :scope >    _i.find(":scope > div") --- cautare de divuri direct childs in contextul _i
    },
});
Object.defineProperties(self, {
    $$: {
        // !!!BAC>>> a se folosi intensiv pt ca izoleaza variabilele di scripturi -- ba chiar e necesar  pt  const si let
        value: function (hnd) {
            document.readyState === "complete" || document.readyState === "loaded" ? hnd.apply(this) : document.addEventListener("DOMContentLoaded", hnd);
        },
    },

    BRAC: {
        value: (function () {
            var o = {
                MSIE: "ms",
                EDGE: "Edge",
                Chrome: "webkit",
                Firefox: "Moz",
                Opera: "o",
                Safari: "webkit",
            };
            for (var v in o)
                if (navigator.userAgent.indexOf(v) >= 0) {
                    return o[v];
                }
            return null;
        })(),
    },
    IS_MOBILE: {
        value: (function () {
            return /mobile/gim.test(navigator.userAgent);
        })(),
    },
    IS_TOUCH: {
        value: (function () {
            return !!((!!("ontouchstart" in self) && navigator.userAgent.indexOf("PhantomJS") < 0) || !!navigator.pointerEnabled || navigator.msPointerEnabled);
        })(),
    },
    STEPS_TO_ROOT: {
        get: function () {
            var rez = "";
            for (var i = 1; i < location.pathname.match(/\//gim).length; i++) rez += "../";
            return rez;
        },
    },
    DOC: {
        value: document.documentElement,
    },
    body: {
        get: function () {
            return document.body;
        },
    },
    SS: { value: sessionStorage },
    SSP: { get: () => { return SS.pointer() } },
    LS: { value: localStorage },
    LSP: { get: () => { return LS.pointer() } },
    NP: { value: Node.prototype },
    EP: { value: Element.prototype },
    NLP: { value: NodeList.prototype },
    delay: {
        value: function (msec) {
            return function (cb) {
                setTimeout(cb, msec);
            };
        },
    },
    BAC: {
        get: function () {
            return session.domain_user === "adi@myadr.ro" || session.domain_user === "bortunadrian@gmail.com";
        },
    },
});

window.css = {}
Object.defineProperties(css, {
    list: {
        value: {}
    },
    add: {
        value: function (ls, version = null) {
            var L = ls;
            if (!Array.isArray(ls)) {
                L = [ls];
            }
            return L.map(str => {
                if (!this.list[str]) {
                    let l = _E('link').setA({ rel: 'stylesheet', dynamic: 'ccs.add', href: str + "?" + (version || window.jsvc || Date.now()) });
                    document.head._(l);
                    this.list[str] = l;
                    return l;
                }
            });
        }
    },
    rem: {
        value: function (str) {
            if (this.list[str]) {
                this.list[str].die();
                delete this.list[str];
            }
        }
    }
})


window.__read__ = "db\\read.val";
window.__utc__ = "db\\read.utc";
window.__tdf__ = "db\\read.tdf";
window.__save__ = "template.save";
window.__code__ = "__code__";
window.__user__ = "users\\get_profile";
window.__sin__ = "sin";
window.__anm__ = "_anm_"; // css animation






const AsyncFunction = async function () { }.constructor; // !!!BAC>>> permite new AsyncFunction 

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// // use Capiatalized  names like Function String ...
// gettype = function (x) {
//     if (x instanceof Map) return "Map";
//     return {}.toString.call(x).match(/\s([a-zA-Z]+)/)[1];
// }; // !!!!!!!!!! do not modify

function gettype(x) {
    if (x instanceof HTMLElement) {
        return x.constructor.name || "HTMLElement";
    }
    if (x instanceof Map) {
        return "Map";
    }
    return {}.toString.call(x).match(/\s([a-zA-Z]+)/)[1];
}



Object.defineProperty(Object.prototype, "istype", {
    value: function (x) {
        return {}.toString.call(this).indexOf(x) >= 0;
    },
    writable: true,
});

HTMLCollection.prototype.each = HTMLCollection.prototype.forEach = NLP.forEach = Array.prototype.forEach;
HTMLCollection.prototype.map = NLP.map = function (hnd) {
    this.forEach(hnd);
    return this;
};
NLP.map = Array.prototype.map;
NLP.indexOf = Array.prototype.indexOf;
NLP.has = function (elm) {
    return [...this].has(elm);
};

/**
 *  * Element Generator
 * @example
 * let xtb = _E("x-table"); // create custom elm
 * xtb.data = [{A:1,B:2},{A:33,B:0}]; // load data
 * body._(xtb); // append to document.body
 *
 * // using a parsable string
 * let ul = _E("<ul><li>1</li><li>2</li></ul>");
 *
 * // wrap anything in a div
 * let wrap = _E('','bla <h1>ABC</h2>').setA({}).css({})
 *
 * @param {tagName} name
 * @param {innerHTML} text
 * @returns {Element}
 */
function _E(name, text) {
    var $;
    switch (true) {
        case name === "" || !name:
            $ = document.createElement("div");
            break; // create  div
        case !name.indexOf("<"):
            $ = document.createElement("div");
            $.innerHTML = name;
            $ = $.firstElementChild;
            break;
        default:
            var c = window.customElements.get(name);
            if (c) {
                $ = new c(); // _E('f-btn')  -- customElement
            } else {
                $ = document.createElement(name); // _E('button')  -- htmlElement
            }
    }
    if (text || text === 0) $.innerHTML = text;
    return $;
}
function _txt(x) {
    return document.createTextNode(x);
}

// appending
NP._ = function (...A) {
    if (A.length > 1) for (var i = 0; i < A.length; i++) this._(A[i]);
    else {
        if (typeof A[0] === "string") {
            //this.innerHTML+=ar[0]; !!! GRESIT -- distruge event listener -- copie oarba a innerHTML
            var $;
            $ = document.createElement("div");
            $.innerHTML = A[0];
            this._.apply(this, [...$.childNodes]);
        } else this.append(A[0]);
    }
    return this;
};
NP._clr = function (...A) {
    // args array constructor
    this.html = "";
    this._(...A); // args array destructor
    return this;
};
NP._ins = function (elm, poz) {
    this.children[poz] ? this.insertBefore(elm, this.children[poz]) : this._(elm);
    return this;
};
NP._poz = function (poz) {
    var parent = this.parent;
    this.die();
    parent._ins(this, poz);
};

NP._top = function (...A) {
    if (A.length > 1) {
        for (let i = A.length - 1; i >= 0; i--) {
            this._top(A[i]);
        }
    } else {
        let fc = this.firstChild,
            ins = A[0];
        if (fc) {
            this.insertBefore(typeof ins === "string" ? _E(ins) : ins, fc);
        } else {
            this._(ins);
        }
    }
    return this;
};

NP._before = function (elm) {
    elm.parentNode.insertBefore(this, elm);
    return this;
};

NP._after = function (elm) {
    try {
        this._before(elm.nextSibling);
    } catch (err) {
        elm.parentNode.appendChild(this);
    }
    return this;
};
NP._up = function (top) {
    if (top) {
        this.parent._top(this);
    } else {
        this.prev && this._before(this.prev);
    }
    return this;
};
NP._down = function (bottom) {
    if (bottom) {
        this.parent._(this);
    } else {
        this.next && this._after(this.next);
    }
    return this;
};
NP.die = function (time) {
    // use  time in seconds like css ---  time >0 fade | time
    var $ = this;
    if (time == 0) {
        var parent = $.parentNode; // uneori nu are parent ??? ciudat
        parent && parent.removeChild($);
    }
    else if (time > 0) {
        $.fade(0, time, function () {
            $.die(-1);
        });
        return;
    } else {
        if (time < 0) {
            // fast --- hidden before delete
            $.setA("hidden");
            setTimeout(function () {
                var parent = $.parentNode; // uneori nu are parent ??? ciudat
                parent && parent.removeChild($);
            }, 0);
        } else {
            $.parent && $.parent.removeChild($);
        }
    }
};
NP._swap = function (elm) {
    var ph = elm.cloneNode();
    ph.oust(this);
    this.oust(elm);
    elm.oust(ph);
    ph = null;
    return [this, elm];
};

NP.replaced = function (elm) {
    this.parentNode.replaceChild(elm, this);
};

NP.oust = NP._oust = function (elm) {
    elm.parentNode.replaceChild(this, elm);
};

// Attributes && Classes
Object.defineProperties(NP, {
    html: {
        get: function () {
            return this.innerHTML;
        },
        set: function (s) {
            this.innerHTML = s;
        },
    },
    find: {
        value: function (str, f) {
            return f ? this.querySelector(str.esc_slash) : this.querySelectorAll(str.esc_slash);
            //return Q(str,this);
        },
    },
    setA: {
        value: function (a, v, clear) {
            if (typeof a !== "string") {
                // setA({a:1,b:2})
                for (var i in a) {
                    this.setA(i, a[i]);
                }
            } else {
                // setA("name","vals")
                if (0 && this.hasAttribute(a) && !clear) {
                    v = ((v || "") + "").split(" ");
                    var s = "";
                    for (var i in v) {
                        if (!this.hasA(a, v[i])) s += v[i];
                    }
                    s && this.setAttribute(a, this.getAttribute(a) + " " + s);
                } else {
                    this.setAttribute(a, v || "");
                }
            }
            return this;
        },
    },
    remA: {
        value: function (a, val) {
            val && this.getAttribute(a) !== null
                ? this.setAttribute(
                    a,
                    this.getAttribute(a)
                        .replace(new RegExp("\\s*" + val, "gim"), "")
                        .trim()
                )
                : this.removeAttribute(a);
            return this;
        },
    },
    getA: {
        value: function (a) {
            if (a) {
                return this.getAttribute(a);
            } else {
                var o = {};
                for (let a of this.attributes) {
                    o[a.name] = a.value;
                }
                return o;
            }
        },
    },
    togA: {
        value: function (a) {
            !!this.hasAttribute(a) ? this.remA(a) : this.setA(a);
            return this.hasA(a);
        },
    },
    tmpA: {
        value: function (name, time) {
            this.setAttribute(name, "");
            setTimeout(
                function () {
                    this.removeAttribute(name);
                    //this.fire("attribute_removed",{attribute:name});
                }.bind(this),
                time || 500
            );
            return this;
        },
    },
    hasA: {
        value: function (a, val) {
            return !!val ? new RegExp("(\\s|^)" + (val + "").trim() + "(\\s|$)").test(this.getAttribute(a)) : this.hasAttribute(a);
        },
    },
    copyA: {
        value: function (elm) {
            var $ = this;
            [...elm.attributes].map(function (atr) {
                $.setAttribute(atr.name, atr.value);
            });
            return this;
        },
    },
    hasC: {
        value: function (c) {
            return new RegExp("(\\s|^)" + c + "(\\s|$)").test(this.className);
        },
    },
    setC: {
        value: function (c) {
            if (!this.hasC(c)) this.className = this.className + " " + c;
            return this;
        },
    },
    remC: {
        value: function (c) {
            this.className = this.className.replace(new RegExp("(\\s|^)" + c + "(\\s|$)"), "");
            return this;
        },
    },
    togC: {
        value: function (c) {
            this.hasC(c) ? this.remC(c) : this.setC(c);
        },
    },
});

/**
 *
 * @param {type} col colectie de elemente  --  suporta array sau NodeList
 * @param {type} attr -- attributul pe care numai un element din colectie poate sa-l aiba
 * @param o -- event_type la care se muta atributul
 * @returns {region_analysis_L2.radio_attr}
 */
function radio_attr(col, attr, o = {}) {
    var $ = this;
    $.collection = col;
    $.attr = attr;
    var event = typeof o === "string" ? o : o.event;
    if (event) {
        $.collection.forEach(function (elm) {
            elm.on(event, function (ev) {
                if ($.selected !== elm) {
                    $.selected = elm;
                }
            });
        });
    }
    $.trig(
        "selected",
        function (elm) {
            var A = $.collection;
            for (var i = 0; i < A.length; i++) {
                A[i].removeAttribute($.attr);
            }
            elm && elm.setA($.attr);
            if ($.memorize) {
                var o = (localStorage.memorized_radio_attr || "{}").parsed;
                o[$.namespace] = o[$.namespace] || {};
                o[$.namespace][$.tab_index] = $.collection.indexOf(elm);
                localStorage.memorized_radio_attr = JSON.stringify(o);
            }
            $.cb && $.cb(elm);
            return elm;
        },
        null
    );
    $.select = function (elm) {
        if (typeof elm === "number") {
            $.selected = $.collection[elm] || null;
        } else $.selected = elm;
    };
    if (o.memorized_by) {
        $.namespace = o.memorized_by[0].memorize;
        $.tab_index = +o.memorized_by[1];
        var active_tab_index = (localStorage.memorized_tabs || "{}").parsed[$.namespace];
        if (+active_tab_index === $.tab_index) {
            // e cazul sa selectez butonul memorat
            var mem = (localStorage.memorized_radio_attr || "{}").parsed[$.namespace] || {},
                but_idx = +mem[$.tab_index];
            if (but_idx >= 0) {
                setTimeout(function () {
                    $.collection[but_idx].click();
                }, 10);
            }
        }
        $.memorize = true;
    }
}

Object.defineProperties(EP, {
    next: {
        get: function () {
            return this.nextElementSibling;
        },
        enumerable: true,
    },
    prev: {
        get: function () {
            return this.previousElementSibling;
        },
        enumerable: true,
    },
    logical_sibling: {
        value: function (arg) {
            var p = this.parent,
                gp = p.parent,
                path = [];
            while (gp && gp !== document) {
                if (gp.find("[logical_row]").has(p)) {
                    break;
                } else {
                    path.push(p.tagName);
                    p = gp;
                    gp = p.parent;
                }
            }
            if (p === document) {
                return false;
            }

            let ls;
            if (p.tagName === "FORM") { // la forme pot sa grupez inputurile in div, field etc deci nu merge  cu > 
                ls = p.find("[name]");
            }
            else {
                ls = p.find(":scope > " + path.reverse().join(" > ") + " > [name]"); // logica de constructie x-form tabular_data
            }

            if (!ls.length) {
                return false;
            }
            if (+arg) {  // a nu  se cauta in forme dupa  index !!!! $0.logical_sibling(-2) este inpredictibil  daca aranjez inputurile altfel decit in database
                for (var e = 0; e < ls.length; e++) {
                    if (ls[e].name === this.name) {
                        return ls[e + arg];
                    }
                }
            } else {
                for (var e = 0; e < ls.length; e++) {
                    if (ls[e].name === arg) {
                        return ls[e];
                    }
                }
            }
        },
    },
    parent: {
        get: function () {
            return this.parentNode;
        },
    },
    first: {
        get: function () {
            return this.firstElementChild;
        },
    },
    last: {
        get: function () {
            return this.lastElementChild;
        },
    },
    group: { // group of elemnts having same search identifier  
        value: function (str, context) {
            var scope = context ? context : this.parentNode;
            if (!scope || scope === document) return null;
            return [...scope.querySelectorAll(":scope" + (context ? " " : ">") + this.nodeName + (str || ""))];
        }
    },
    siblings: {
        value: function (str, context) {
            var rez = this.group(str, context) || [];
            rez.splice(rez.indexOf(this), 1);
            return rez; // !!!!!!!!!!!!!!! ATENTIE returneaza Array (nu NodeList)
        }
    },
    nth: { // What is my position among siblings matching a selector?
        value: function (str, context) {
            const g = this.group(str, context);
            return g ? g.indexOf(this) : -1;
        }
    },
    dom_index: { // What is my physical position among my parent's children?
        get: function () {
            return this.parentNode ? Array.prototype.indexOf.call(this.parentNode.children, this) : null;
        },
    },
    ancestors: {
        value: function (top = document) {
            if (top !== document && !top.contains(this))
                return null;

            let A = [];
            let parent = this.parent;

            while (parent) {
                A.push(parent);
                if (parent === top) break;
                parent = parent.parent;
            }

            return A.reverse();
        }
    },

    __closest: {
        // opozite of find --- exista un nativ dar care da in bot la x-form unde folosesc __closest   --- EP.closest aduce  si elemntul in sine  -- closest_parent
        value: function (str) {
            var p = this.parent,
                gp = p.parent;
            while (gp && gp !== document) {
                if (gp.find(str).has(p)) {
                    return p;
                } else {
                    p = gp;
                    gp = p.parent;
                }
            }
            return false;
        },
    },
    closest_parent: {
        value: function (selector) {
            var p = this.parent.closest(selector);
            return p;
        },
    },
    desc: {
        value: function (elm) {
            return elm.contains(this);
            // var x = this;
            // return isDescendant(x, elm);
        },
    },
    ascend: {
        value: function (elm) {
            //return elm.desc(this);
            return this.contains(elm);
        },
    },
    overflow: {
        get: function () {
            var $ = this,
                cw = $.clientWidth,
                sw = $.scrollWidth,
                ch = $.clientHeight,
                sh = $.scrollHeight;
            return {
                w: cw < sw,
                h: ch < sh,
                dx: sw - cw,
                dy: sh - ch,
                clientWidth: cw,
                scrollWidth: sw,
                clientHeight: ch,
                scrollHeight: sh,
            };
        },
    },
    tagString: {
        get: function () {
            return this.outerHTML.match(/<.*?>/)[0].replace(/^</, "&lt;");
        },
    },
    lock: {
        value: function () {
            this.find("textarea,select").map(function (elm) {
                var repl = _E("lock", elm.value.replace(/[\n\r]/gims, '<br/>'));
                repl.copyA(elm).remA("disabled");
                repl.oust(elm);
                repl.auto_resize_height();
            });
            this.find("[del]").remA("del");
            this.find("[dummy]").setA("lock");
            this.setAttribute("locked", 1);
        },
    },
    flaten: {
        value: function () {
            var $ = this;
            var R = _E().setA("flatened_input");
            R.copyA($);
            R.remA("disabled").setA("locked");
            R.w = $.w;
            R.html = "<lock></lock>" + $.value;
            R.flatened_input = $;
            R.oust($);
            return R;
        },
    },
    deflaten: {
        value: function () {
            var $0 = this.flatened_input;
            if ($0) {
                $0.oust(this);
                return $0;
            }
            return false;
        },
    },
    frozen: {
        set: function (on_off) {
            this.style.pointerEvents = on_off ? "none" : "inherit";
            on_off ? this.setA("frozen") : this.remA("frozen");
        },
    },
    kids: {
        get: function () {
            return [...this.children];
        },
    },
    ck0: {
        get: function () {
            let evt = getEventListeners(this);
            if (evt["click"]) {
                return evt["click"].length > 1 ? evt["click"].collect_prop('listener') : evt["click"][0].listener;
            } else {
                return null;
            }
        },
    },
    ck1: {
        get: function () {
            let evh = this.ck0;
            if (!evh) {
                let p = this.parent;
                if (p) {
                    return p.ck1;
                } else {
                    return evh;
                }
            } else {
                return evh;
            }
        },
    },
    serialized: {
        get: function () {
            return new XMLSerializer().serializeToString(this);
        },
    },
    fixified: {
        set: function (x) {
            var $ = this;
            if (!!x) {
                if (!$._fixify_holder_) {
                    $._fixify_holder_ = _E().setA("fixify_holder");
                    $._fixify_holder_.oust($);
                    var btn = _E().setA("fixify_switcher").css("display:inline-block;position:absolute");
                    var drag_bar = _E().setA("drag_bar");//.css();
                    $._fixify_holder_._(_E().css("position:relative")._(btn), drag_bar);
                    $._fixify_holder_._($);
                    btn.on("click", ev => {
                        $._fixify_holder_.tmpA(__anm__);
                        $._fixify_holder_.txy = [0, 0];
                        var a = $._fixify_holder_.togA("active");
                        a ? drag_bar.dragParent() : drag_bar.undragParent();
                        if (!a) {
                            window.scrollTo({
                                top: $.parent.offsetTop - 100,
                                behavior: 'smooth',
                            });
                        }
                    });
                }
            }
            else {
                $.oust($._fixify_holder_)
                $._fixify_holder_ = false;
            }
        }
    }
});



// DOM
function isDescendant($, ancestor) {
    if (!$) return false;
    return $.parentNode === ancestor || ($.parentNode !== document && isDescendant($.parentNode, ancestor));
}

//alternative
NP.has = function (elm) {
    return this.childNodes.has(elm);
};

// NodeList
NLP._ = function (s) {
    for (var i = 0; i < this.length; i++) {
        var ap = s.cloneNode(1);
        this[i]._(ap);
    }
};

NLP._top = function (s) {
    for (var i = 0; i < this.length; i++) {
        var ap = s.cloneNode(1);
        this[i]._top(ap);
    }
};

// utile
function nf() { } // do not make anonimous function

function error(data) {
    try {
        dn(data, "ERROR");
    } catch (err) {
        alert(data);
    }
}

Object.defineProperties(String.prototype, {
    rgx: {
        get: function () {
            return new RegExp(this, "gims");
        },
    },
    has: {
        value: function (s) {
            return this.indexOf(s) >= 0;
        },
        writable: true,
    },
    capitalize: {
        value: function () {
            return this.charAt(0).toUpperCase() + this.slice(1);
        },
    },
    smallize: {
        value: function () {
            return this.charAt(0).toLowerCase() + this.slice(1);
        },
    },
    esc_slash: {
        //  ?? gresit
        get: function () {
            return this.replace(/\//gim, "\\/");
        },
    },
    esc_css_selector: {
        get: function () {
            return this.replace(/\//gim, "\\/").replace(/\./gim, "\\.").replace(/`/gim, "");
        },
    },
    esc4html: {
        get: function () {
            return _E("", this).html;
        },
    },
    dom: {
        value: function () {
            var parser = new DOMParser();
            return parser.parseFromString(this, "text/xml");
        },
    },
    limit: {
        value: function (x) {
            return this.length > x ? this.substring(0, x) : this;
        },
    },
    htmlentities: {
        get: function () {
            return this.replace(/<!--/gim, "&lt;!--").replace(/<([^>]*?)>/gim, "&lt;$1>");
        },
    },
    s2o: {
        get: function () {
            var o = {};
            var p = this.split(";");
            for (var v in p) {
                if (!p[v]) continue;
                var tmp = /([^:]*):(.*$)/gim.exec(p[v]);

                if (tmp) {
                    o[tmp[1].trim()] = tmp[2].trim();
                }
            }
            return o;
        },
    },
    parsed: {
        get: function () {
            return JSON.parse(this);
        },
    },
    eval: {
        get: function () {
            let v;
            eval("v=" + this);
            return v;
        },
    },
    basename: {
        get: function () {
            return this.match(/[^\/]*$/)[0];
        },
    },
    trim_by: {
        value: function (str) {
            const esc = str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
            const rgx = new RegExp(`^(?:${esc})+|(?:${esc})+$`, "g");
            return this.replace(rgx, "");
        },
    },
    dirname: {
        get: function () {
            let a = this.split("/");
            a.pop();
            return a.join("/");
        },
    },
    nve: {
        get: function () {
            var r = (/(\(\d+\))(\.[^\.]*?)$/.test(this) ? /(.*)(\((\d+)\))(\.[^\.]*?)$/.exec(this) : /(.*)((.?))(\.[^\.]*?)$/.exec(this)) || [this, null, null];
            var out = { n: r[1], v: parseInt(r[3]) || 0, e: r[4] };
            return out;
        },
    },
    random: {
        value: function (L = 5) {
            var r = "",
                s = "abcdefghijklmnopqrstuvwxyz0123456789";
            for (let i = 0; i < L; i++) {
                r += s[Math.floor(Math.random() * s.length)];
            }
            return this + r;
        },
    },
    gshup: {
        value: function (length = 50) {
            return this.length > length ? this.substr(0, length) + "<gshup><m>" + this + "</m></gshup>" : this + "";
        },
    },
    explode: {
        value: function (sep = '') {
            return this.length ? this.split(sep) : [];
        }
    },
    hash: { // !!!BAC>>> async 
        value: async function (alg = 'SHA-256') {
            return crypto.subtle.digest(alg, new TextEncoder().encode(this))
                .then(buf => Array.from(new Uint8Array(buf))
                    .map(b => b.toString(16).padStart(2, '0')).join(''));
        }
    },
    SHA512: {
        get: function () {
            return CryptoJS.SHA512(this + "").toString();
        }
    },
    tblcln: {
        get: function () {
            let o = {}, a = this.split(".");
            o.cln = a.pop();
            o.tbl = a.join(".");
            return o;
        }
    }
});

String.concat = function (...A) {
    return A.join("");
};

//CLONE OBECT
//clone=
function cloneObject(o, deep) {
    // do not clone DOM Elements --  this is just for pure js object
    var out = gettype(o) === "Object" ? {} : [];
    --deep;
    for (var i in o) {
        var type = gettype(o[i]);
        if ((type === "Object" || type === "Array") && (deep >= 0 || !+deep)) {
            out[i] = new cloneObject(o[i], deep);
        } else {
            out[i] = o[i];
        }
    }

    return out;
}

function mergeObjects(...a) {
    var c = {};
    for (var i = 0; i < a.length; i++) {
        for (var v in a[i]) c[v] = a[i][v];
    }
    return c;
}
// CONFLICT CU
// import("https://cdn.rawgit.com/lodash/lodash/4.17.4-es/lodash.default.js")then(({default:_})=>{...})
//  tail, toArray, drop -- eunle declar globale si fortez _.toArray sa fie altceva  -- naspa cu MODULE

Object.defineProperties(Object.prototype, {
    has: {
        // vede si proprietatile mostenite ca ex toString
        value: function (p) {
            return p in this;
        },
        writable: true,
    },
    tail: {
        // atentie nu face decit sa preia level 1 ca referinte si suprascrie prop originalului - e f buna ca sa faca append de obiecte mari ca si referinta
        value: function (...A) {
            A.map((o) => {
                for (var v in o) this[v] = o[v];
            });
            return this;
        },
        writable: true,
    },
    raw_copy: {
        // metoda de clonare
        value: function (deep) {
            return cloneObject(this, deep);
        },
        writable: true,
    },
    flat_copy: {
        value: function () {
            return JSON.stringify(this).parsed;
        },
        writable: true,
    },
    miror: {
        value: function () {
            return [].combine(Object.values(this), Object.keys(this));
        },
        writable: true,
    },
    bac_swap: {
        value: function (i1, i2, prop) {
            if (prop == undefined) {  // swap array indexes or object properties-values  [1,2,3].bac_swap(0,1) -> [2,1,3] or ({a:1,b:2,c:3}).bac_swap('a','c') -> {a:3,b:2,c:1}
                let buf = this[i1];
                this[i1] = this[i2];
                this[i2] = buf
            }
            else {
                // swap collections on set.property [{a:1,b2},{a:2,b:5},{a:3,b:1111}].swap(1,3,'a') -> [{a:3,b:1111},{a:2,b:5},{a:1,b:2}]
                // are sens numai pt valori unice (id)
                var idx_1, idx_2;
                this.map((s, idx) => {
                    if (s[prop] === i1) {
                        idx_1 = idx
                    };
                    if (s[prop] === i2) {
                        idx_2 = idx
                    };
                });
                this.bac_swap(idx_1, idx_2);
            }
            return this;
        }, writable: true,
        configurable: true
    },
    toArray: {
        // se aplica numay la obiecte array_like  NodeList args....
        value: function () {
            return Array.prototype.slice.call(this);
        },
        writable: true,
    },
    pkeys: {
        //  array of property names  ...  daca folosesc keys crapa js
        value: function () {
            var rz = [];
            for (var v in this) rz.push(v);
            return rz;
        },
        writable: true,
    },
    trh: {
        value: function (as_dom) {
            //nu merge as dom
            var rez;
            if (as_dom) {
                rez = _E("tr");
                for (var v in this) {
                    rez._(_E("th", v).setA("c_name", v));
                }
            } else {
                rez = "<tr>";
                for (var v in this) {
                    rez += "<th c_name=" + v + ">" + v + "</th>";
                }
                rez += "</tr>";
            }
            return rez;
        },
    },
    trd: {
        value: function (as_dom) {
            var rez;
            if (as_dom) {
                rez = _E("tr");
                for (var v in this) {
                    rez._(_E("td", this[v]).setA("c_name", v));
                }
            } else {
                rez = "<tr>";
                for (var v in this) {
                    var html = this[v];
                    if (html == null || html == 'null') {
                        html = '';
                    }
                    rez += '<td c_name="' + v + '">' + html + "</td>";
                }
                rez += "</tr>";
            }

            return rez;
        },
    },
    pointer: {
        // !!!BAC>>> ATENTIE e gandit pt RAW_JS_OBJECT   orice altceva se poate serialza prost sau cu error
        value: function (arr, val) {
            if (typeof arr === "string") {
                arr = arr.split(".");
            }
            var brr = [];
            var c = false;

            arr.map(e => {  // escaping segments containing dot with  ``  EX  MAP2_DICTIONARY.pointer("  `ALL_ADR.n_localitati_view.id` . lcjd ")
                if (e === null) {
                    // console.log(arr, val)
                    return;
                }
                if (e[0] === '`') {
                    c = [e.replace(/`/, '')]; // activare colector
                } else {
                    if (c) {
                        if (/`$/.test(e)) {
                            c.push(e.replace('`', ''));
                            brr.push(c.join('.'))
                            c = false;  // dezactivare  colector 
                        } else {
                            c.push(e);
                        }
                    } else {
                        brr.push(e)
                    }
                }
            });

            try {
                // asignare directa  
                return eval("this['" + brr.join("']['") + "']" + (val !== undefined ? "=" + JSON.stringify(val) : ""));
            } catch (e) {
                if (val !== undefined) {
                    var o = this;
                    brr.map((p, idx) => {
                        if (!o.hasOwnProperty(p)) {
                            // parseInt(arr[idx + 1]) + 1 ? o[p] = [] : o[p] = {}; //  nu are rost sa fortez array !!!BAC>>> chiar nu are !!!
                            o[p] = {};
                        }
                        o = o[p]; // reference passed object
                    });
                    // RECURSION
                    return this.pointer(arr, val);
                } else {
                    return undefined;
                }

            }
        },
        writable: true,
    },
    o2s: {
        value: function () {
            var rez = "",
                o = gettype(this) === "String" ? this.parsed : this;
            for (var v in o) {
                rez += v + ":" + o[v] + ";";
            }
            return rez;
        },
    },
    // generez get string for browser
    o2get: {
        value: function () {
            var rez = "";
            for (var v in this) {
                rez += "&" + v + "=" + this[v];
            }
            return rez;
        },
    },
    __isEmpty: {
        value: function () {
            if (gettype(this) === "Array") {
                return this.length === 0;
            } else {
                for (var p in this) {
                    if (this.hasOwnProperty(p)) {
                        return false;
                    }
                }
                return true;
            }
        },
    },
    crop_keys: {
        //  o= {a:1,b:2,c:3};o.crop_keys('a,c');
        // [{a:1,b:2,c:3},{a:2,b:4,c:5,d:44}].crop_keys(["a","b"]);
        value: function (keys, unique) {
            if (typeof keys === "string") {
                keys = keys.split(",").trim();
            }
            var rez;
            if (Array.isArray(this)) {
                rez = this.map((o) => {
                    return o ? o.crop_keys(keys) : {};
                });
            } else {
                rez = {};
                for (var p in keys) {
                    if (this.hasOwnProperty(keys[p])) rez[keys[p]] = this[keys[p]];
                }
            }
            return unique ? rez.unique() : rez;
        },
        writable: true,
    },

    /**
     * trimit un array de proprietati ale obiectului la care se renunta definitiv pe sursa
     */
    drop: {
        value: function (props_arr) {
            var $ = this;
            props_arr.each(function (prop) {
                delete $[prop];
            });
            return $;
        },
        configurable: true,
        writable: true,
    },
    traverse: {
        value: function (fn) {
            var out = {};
            for (var v in this) {
                out[v] = fn(this[v], v);
            }
            return out;
        },
        writable: true,
    }

});

!Object.prototype.hasOwnProperty("values") &&
    Object.defineProperty(Object.prototype, "values", {
        value: function () {
            var rz = [];
            for (var v in this) {
                rz.push(this[v]);
            }
            return rz;
        },
        writable: true,
    });

// like map from array
Object.defineProperty(Object.prototype, "scan", {
    value: function (cb) {
        return Object.entries(this).map(([k, v], idx) => {
            return cb.call(this, k, v, idx);
        });
    },
    configurable: true,
    writable: true,
});



Object.defineProperty(Object.prototype, "scan_async", {
    value: async function (cb) {
        const result = [];
        const entries = Object.entries(this);
        for (let i = 0; i < entries.length; i++) {
            const [k, v] = entries[i];
            result.push(await cb.call(this, k, v, i));
        }
        return result;
    },
    configurable: true,
    writable: true,
});


Object.defineProperty(Map.prototype, "scan", {
    value: function (cb) {
        let idx = 0;
        const res = [];

        for (const [k, v] of this) {
            res.push(cb.call(this, k, v, idx++));
        }
        return res;
    }
});

Object.defineProperty(Object.prototype, 'sort_keys', {
    value: function (desc = false) {
        let m = desc ? -1 : 1,
            o = this,
            v = { ...o },
            keys = Object.keys(o)[desc ? "rsort" : "sort"]();
        keys.map(k => {
            delete this[k];
            this[k] = v[k];
        });
        return this;
    }
});

Object.defineProperty(Object.prototype, 'rsort_keys', {
    value: function () {
        return this.sort_keys('reverse');
    }
});

/*
 * EX
 * LS.pointer( "a.b.c", [1,2] ); // scriere un [1,2] in pathul a.b.c
 * LS.pointer("a.b.c.[1]") -> 2   // citire
 * LS.pointer(["a","b"],false)   // stergere  b
 * LS.pointer() // lists everithing
 *       !!!BAC>>>  a nu se confunda cu pointerul de variabila normala   ---  asta e pointer de storage care lucreaza numai cu valori serializabile  peste  localStorage sau sessionStorage
 */
Object.defineProperty(Storage.prototype, "pointer", {
    // LocalStorage, SessionStorage behave like dinamic object but auto-updates on every change on any level
    value: new Proxy(
        function (str) {
            return /^[\[\{]/.test(str);
        },
        {
            apply(fn, STG, p) {
                // p = [path,value]
                switch (p.length) {
                    case 0: // citesc toate itemurile (parsate ???)
                        var V = {};
                        for (let i = 0; i < STG.length; i++) {
                            let k = STG.key(i),
                                item = STG.getItem(k);
                            V[k] = fn(item) ? item.parsed : item;
                        }
                        return V;
                        break;
                    case 1:
                        p = p[0];
                        var arr = typeof p === "string" ? p.split(".") : p,
                            stg_item = arr.shift();
                        if (!STG[stg_item]) { // !?
                            return STG[stg_item];
                        } else {
                            var V = STG[stg_item].parsed;
                            return arr.length ? V.pointer(arr) : V;
                        }
                        break;
                    default: //2// vreau sa scriu
                        var val = p[1];
                        p = p[0];
                        var arr = typeof p === "string" ? p.split(".") : p,
                            stg_item = arr.shift(),
                            V = (STG[stg_item] || "{}").parsed;
                        if (arr.length) {
                            if (val === false) {
                                var prop_to_delete = arr.pop(),
                                    O = arr.length ? V.pointer(arr) : V; // referinta  nu asignare
                                if (O) {
                                    if (Array.isArray(O)) {
                                        O.splice(prop_to_delete, 1);
                                    } else {
                                        delete O[prop_to_delete];
                                    }
                                }
                            } else {
                                V.pointer(arr, val);
                            }
                        } else {
                            V = val;
                        }
                        if (V === false) {
                            delete STG[stg_item]; //
                        } else {
                            STG[stg_item] = JSON.stringify(V);
                        }
                        break;
                }
            },
        }
    ),
});

Object.defineProperties(Object.prototype, {
    combine: {
        /**
         * exemple:       [].combine(['a','b'],[3,4]) --> {a:3,b:4}
         * @param {array} keys_arr
         * @param {array} vals_arr
         * @returns {object}
         */
        value: function (keys_arr, vals_arr) {
            var o = {};
            for (var v in keys_arr) {
                o[keys_arr[v]] = vals_arr[v];
            }
            return o;
        },
        writable: true,
    },
    // test:{}
    contains_obj: {
        // a fost proprietatea  test
        value: function (obj) {
            for (var p in obj) {
                if (this[p] != obj[p]) {
                    return false;
                }
            }
            return true;
        },
    },
    normalize: {
        // -- uniformizarea colectiilor de obiecte -- toate sa aiba aceleasi proprietati
        // obj={a:{c1:0,c3:1},b:{c1:3,c2:1},c:{c2:33,c4:2,c5:1}}
        // arr=[{c1:0,c3:1},{c1:3,c2:1},{c2:33,c4:2,c5:1}]
        value: function () {
            let o = this,
                p = Array.isArray(o) ? [] : {},
                s = new Set();
            for (let i in o) {
                for (let j in o[i]) {
                    s.add(j);
                }
            }
            for (let i in o) {
                p[i] = {};
                s.forEach((c) => {
                    p[i][c] = o[i][c] ?? null;
                });
            }
            return p;
        },
        writable: true,
    },
});

function deepOverwrite(o1, o2) {
    // o1 is target to be modified
    for (const k in o2) {
        const v = o2[k];

        if (
            v &&
            typeof v === "object" &&
            !Array.isArray(v) &&
            o1[k] &&
            typeof o1[k] === "object" &&
            !Array.isArray(o1[k])
        ) {
            // recurse only to find nested keys
            deepOverwrite(o1[k], v);
        } else {
            // replace completely
            o1[k] = structuredClone(v);
        }
    }
    return o1;
}

Object.defineProperty(Object.prototype, 'overwrite', {
    value: function (o = {}) {
        return deepOverwrite(this, o);
    }
})


Object.defineProperty(Object.prototype, 'clone', {
    value: function () { return structuredClone(this); },
    configurable: true,
    writable: true,
});



// array.has() method
Object.defineProperties(Array.prototype, {
    implode: {
        value: function (sep) {
            return this.join(sep);
        }
    },
    rsort: {
        value: function () {
            return this.sort().reverse();
        }
    },
    each: {
        value: Array.prototype.forEach,
        writable: true,
    },
    has: {
        value: function (o, flag) {
            if (flag === undefined) {
                return this.indexOf(o) !== -1;
            } else {
                for (var v in this) {
                    if (JSON.stringify(this[v]) === JSON.stringify(o)) return true;
                }
                return false;
            }
        },
        writable: true,
    },
    clone: {
        value: function () {
            return this.raw_copy(0);
        },
        writable: true,
    },
    remove: {
        // remove element by value not by index ???
        value: function (...A) {
            var what,
                a = Array.isArray(A[0]) ? A[0] : A,
                L = a.length,
                ax;
            while (L && this.length) {
                what = a[--L];
                while ((ax = this.indexOf(what)) !== -1) {
                    this.splice(ax, 1);
                }
            }
            return this;
        },
        writable: true,
    },
    drop: {
        value: function (idx) {
            if (typeof idx === "number") {
                return this.splice(idx, 1);
            } else if (gettype(idx) === "Array") {
                // array of indexes to be dropped;
                var indexes = idx.sort().reverse(),
                    removed = [];
                for (var i in indexes) {
                    removed.push(this.splice(indexes[i], 1)[0]);
                }
                return removed.reverse();
            } else {
                //console.log(idx, gettype(idx));
                try {
                    return this.splice(parseInt(idx), 1);
                } catch (e) {
                    alert("PROBLEMA IN SESSION.DROP() \n" + idx + "\n" + gettype(idx));
                }
            }
            return this;
        },
        writable: true,
    },
    clean: {
        value: function () {
            this.splice(0, this.length);
            return this;
        },
        writable: true,
    },
    insert: {
        value: function (idx, val) {
            this.splice(idx, 0, val);
            return this;
        },
        writable: true,
    },
    /**
     * a.add(arr_b) modifica a prin adaugarea elementelor lui arr_b
     * daca vreau uniq se adauga numai elemetele lui b pe care a nu le are deja
     */
    add: {
        value: function (arr, uniq) {
            if (typeof arr !== "object") {
                arr = [arr];
            }
            if (uniq) {
                for (var i in arr) {
                    !this.has(arr[i]) && this.push(arr[i]);
                }
            } else {
                Array.prototype.push.apply(this, arr);
            }
            return this;
        },
        writable: true,
    },
    as1: {
        value: function (s, t, cb) {
            var $ = this;
            return function (...arg) {
                for (var i = 0; i < $.length; i++) {
                    (function (i) {
                        setTimeout(function () {
                            typeof s === "string" ? $[i][s].apply($[i], arg) : s.apply(this, [$[i], ...arg]);
                        }, i * 1 * (t || 0));
                    })(i);
                }
                setTimeout(function () {
                    (cb || nf).bind($)($, ...arg);
                }, $.length * (t || 0));

                return $;
            };
        },
        writable: true,
    },
    unique: {
        // asta e bun si suporta orice element type
        value: function (by_value) {
            var r = [],
                $ = this;
            for (var v in this) if (!r.has($[v], by_value)) r.push($[v]);
            return r;
        },
        writable: true,
    },
    last: {
        value: function () {
            return this.slice(-1)[0];
        },
        writable: true,
    },
    min: {
        value: function () {
            return Math.min.apply(null, this);
        },
        writable: true,
    },
    max: {
        value: function () {
            return Math.max.apply(null, this);
        },
        writable: true,
    },
    fill_new: {
        // numeric array
        value: function (value, length) {
            var A = [],
                i = 0;
            while (i < length) A[i++] = Array.isArray(value) ? (value[i - 1] || '') : value;
            return A;
        },
    },
    range: {
        value: function (a, b, step) {
            var A = [];
            if (typeof a === "number") {
                A[0] = a;
                step = step || 1;
                while (a + step <= b) {
                    A[A.length] = a = +(a + step).toFixed(3);
                }
            } else {
                var s = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
                s = s.substring(s.indexOf(a), s.indexOf(b) + 1);
                A = s.split("");
            }
            return A;
        },
        writable: true,
    },
    shuffle: {
        value: function () {
            var j, x, i;
            for (i = this.length - 1; i > 0; i--) {
                j = Math.floor(Math.random() * (i + 1));
                x = this[i];
                this[i] = this[j];
                this[j] = x;
            }
            return this;
        },
        writable: true,
    },
    random_pick: {
        value: function () {
            return [...this].shuffle()[Math.floor(Math.random() * this.length)];
        },
    },
    /**
     *
     */
    find_set: {
        // cauta in array of arrays setul care are valoarea val in pozitia  ...  daca dau get_id intoarce index-ul setului
        value: function (val, idx, return_id) {
            for (var i in this) {
                if (this[i][idx] == val) return return_id ? +i : this[i]; // equal not identical ca sa egalizeze ca string
            }
            return return_id ? null : [];
        },
    },
    filter_sets: {
        // array of arrays
        value: function (value, position) {
            return this.filter(function (item) {
                return item[position] === value;
            });
        },
    },
    remove_set: {
        // merge si cu obiecte remove_set(75,'id')
        value: function (val, idx) {
            var poz = this.find_set(val, idx, 1);
            return this.splice(poz, 1);
        },
    },
    /**
     *  // cauta in array of objects toate elementele care sunt de tipul o adica  elm ={a:1,b:2} este o extensie  pt o={a:1} dar nu pt {a:2}
     */
    find_obj: {
        value: function (o, get_idx) {
            var rez = []; //, idx = -1;
            for (var v in this) {
                if (this[v]) {
                    var bool = true;
                    //  idx++;
                    for (var p in o) {
                        if (!this.hasOwnProperty(v) || this[v][p] != o[p]) {
                            bool = false;
                            break;
                        }
                    }
                    bool && rez.push(get_idx ? +v : this[v]);
                }
            }
            return rez;
        },
    },
    /**
     * select  from  array of objects
     * @param o is   {p:["A",0,"b"...],c:"$ == 3"} -->  p is path pointer , c is condition
     * ex
     * o = {A:[{B:{c:3}}]}; a=[o,{A:[{B:{x:1,c:5}}]}];a.dig({p:["A",0,"B","c"],c:"$ === 3|| $ <2"})
     *
     *
     * BAC ...  trebuie extins cu path "a.*.*.b" in care * inseamna any adica tori index-si sau toate pkeys -- adica vreau toate elementele care la o anumita adincime au o valoare care respecta o conditie
     */
    dig: {
        value: function (path, cond, idx) {
            var rez = [];
            if (typeof path === "string") {
                path = path.split(".");
            }
            if (typeof cond !== "string") {
                cond = " true";
            }
            this.map((s, i) => {
                if (s) {
                    var v = s.pointer(path);
                    //console.log(v);
                    if (v !== undefined && eval(cond.replace(/\$/gim, typeof v === "string" ? '"' + v + '"' : v))) {
                        idx ? rez.push(i) : rez.push(s);
                    }
                }
            });
            return rez;
        },
        writable: true,
    },
    extract: {
        value: function (path, cond = true, acum = this) {
            if (typeof path === "string") {
                path = path.split(".");
            }
            var sgm = path.shift(),
                rez = [];
            if (sgm === "*") {
                this.map((s) => {
                    Array.isArray(s) && s.map((o) => rez.push(o));
                });
            } else {
                this.map((s) => s[sgm] && rez.push(s[sgm]));
            }
            if (path.length) {
                return rez.extract(path, cond);
            } else {
                if (cond === true) {
                    return rez;
                } else {
                    return rez.having(cond);
                }
            }
        },
        writable: true,
    },
    /**
    EXEMPLU : 

    a0=[
        {
            "a": 1,
            "b": 1,
          c:{d:2,e:4}
        },
        {
            "a": 2,
            "b": 2,
          c:{d:1,e:5}
        }
    ]

    a1=[ {
            "a": 1,
            "b": 1,
          c:{d:2,e:4}
        },
        {
            "a": 1,
            "b": 1,
          c:{d:1,e:4}
        },
        {
            "a": 2,
            "b": 2,
          c:{d:1,e:4}
        }
    ]

    a2=[
        {
            "a": 1,
            "b": 1,
          c:{d:25,e:45}
        },
        {
            "a": 2,
            "b": 2,
          c:{d:551,e:5555}
        }
    ]
    
    a0.intersect(a1,["c"]) --> [a0[0],a0[1]]   ... but ...  a0.intersect(a1,["c"]) --> [a0[0]] 

    a0.alike(a2,["c"]) -> true .... but ....  a0.alike(a2) --> false
     */
    intersect: {
        value: function (arr, collection, ignore) {
            if (collection) { // a0=[{},{},{}] a1=[{},{}.....]  a0.intersect(a1,true,["id","p_id"])
                return this.filter((a) => {
                    let r = false;
                    for (let i = 0; i < arr.length; i++) {
                        if (arr[i].alike(a, ignore)) {
                            r = true;
                            break;
                        }
                    }
                    return r;
                })
            }
            else {
                // ["A", 2, 3].intersect([2, 4, 6, "A"]) => ["A", 2]
                return this.filter((value) => -1 !== arr.indexOf(value));
            }
        },
        writable: true,
    },
    diff: {
        value: function (arr) {
            return this.filter((value) => -1 === arr.indexOf(value));
        }, writable: true
    },
    having: {
        /**
         * !!!ATENTIE -- REFERINTA catre elementele din original ---  se poate rupe   asa  S = COLECTION.having(condition).raw_copy() dar nu {...COLECTION.having(condition)} sau [...COLECTION.having(condition)]
         * !!!ATENTIE --- accepta obiect de obiecte  {1:{},3:{}} -- ex hr.stc_by_id dar intoarce  ARRAY of objects
         *
         * COLECTIE = 'array of complex objects with same structure '     COL = [{a:1,b:2},{a:2,b:1},{a:3,b:1},{a:4,b:5},{a:5,b:5},{a:1,c:{d:1,e:["alfa"]}},{c:{d:1,e:["alfa","beta"]}}];
         *
         * ex1 -- using  filtering objects
         * COL.having({b:5,a:4},{a:[2,3]}) -> selecteaza seturile care au (b=5 si a=4) sau a = 2 sau a=3
         *
         * ex2 ---  using logical expresion
         * COL.having("${b} > 1 && ${a} > 4 ") --> [{a:5,b:5}]  ATENTIE nu se foloseste  = ca e asignare ci == sau ===
         *
         * ex3 ---  using regular expression
         * COL.having("/^55/.test('${b}')") --> seturi in care b incepe cu 55   AM ales stilul PHP pt desemnarea variabilelor  --- ATENTIE la SINGLE-QUOT
         * COL.having("${c} == 3 || ${a}===1 && ${b}===2")
         *
         *
         * ex4 --- DEEP SEARCH POINTER
         * COL.having("$@.c.e[1] !== undefined || $@.a > 2")
         * 
         * ex5 -- comparing dates having("${dt_solve} <= Date('2025-12-02')") -- Date( ... ) is mandatory flag
         * @returns {array}
         */
        value: function (...A) {
            var selected = [];
            for (var i in A) {
                var o = A[i];
                for (var v in this) {
                    try {
                        var bool = true,
                            set = this[v];
                        if (typeof o === "string") {
                            if (/\$@/.test(o)) {
                                // Function -- DEEP SEARCH
                                var str = o.replace(/(\$@)([^\s=<>!\)]*)/gim, function (p, i, j) {
                                    var a = j.match(/[^\.\[\]]+/gim);
                                    return " _x_" + (a.length ? ".pointer(" + JSON.stringify(a) + ")" : ""); //
                                });
                                bool = new Function("_x_", "return " + str)(set);
                            } else {
                                // eval cu rgx
                                if (/Date\(['"].*['"]\)/.test(o)) {
                                    str = o.replace(/\$\{(.*?)\}/g, function (p, i) {
                                        return new Date(set[i]).getTime();
                                    });
                                    // convert Date('...') to timestamp
                                    str = str.replace(/Date\(['"](.*?)['"]\)/g, function (p, d) {
                                        return new Date(d).getTime();
                                    });
                                } else {
                                    var str = o.replace(/(['"])?\s*\$\{(.*?)\}\s*\1?/gim, function (p, q, i) {
                                        const v = set[i];
                                        return typeof v === "string" ? "'" + String(v).replace(/'/g, "\\'") + "'" : v;
                                    });
                                }
                                bool = eval(str);
                            }
                        } else {
                            for (var p in o) {
                                // explicit NULL comparison
                                if (o[p] === null) {
                                    if (this[v][p] !== null) {
                                        bool = false;
                                        break;
                                    }
                                }
                                // array / set semantics
                                else if (typeof o[p] === "object") {
                                    if (!(o[p] || {}).has(this[v][p])) {
                                        bool = false;
                                        break;
                                    }
                                }
                                // scalar comparison (type-agnostic by design)
                                else {
                                    if (!this[v] || this[v][p] != o[p]) {
                                        bool = false;
                                        break;
                                    }
                                }
                            }

                        }
                        if (bool) {
                            selected.push(this[v]);
                        }
                    } catch (e) {
                        console.log("INPUT:", o, "\nCOND:", A, "\n", e);
                    }
                }
            }
            return selected;
        },
        writable: true,
    },
    /**
     * pt arr_obj --> TE.assoc('vcr').aggregate(["val_oi","tva_oi"]) sau pt arr_arr --> TE.data.vcr.aggregate([7,8])
     *{ 
     *  val_oi : {
     min : 500
     max : 6666.67
     avg : 3585.835
     sum : 14343.34
     },
     tva_oi : {
     min : 95
     max : 1333.33
     avg : 715.915
     sum : 2863.66
     }
     }
     */
    //{min:..,max:..,avg:...,sum:...}


    aggregate: {
        value: function (arr_or_string, opts = {}) {
            const fields = typeof arr_or_string === "string" ? [arr_or_string] : arr_or_string;
            if (this.length === 0) return null;

            const rez = {};
            // const values_by_field = {};

            for (const f of fields) {
                const values = this.map(row => Q.float0(row[f]));
                //  values_by_field[f] = values;

                rez[f] = {
                    min: Stats.min(values),
                    max: Stats.max(values),
                    sum: Stats.sum(values),
                    avg: Stats.avg(values),
                };
                opts.scan(stat => {
                    if (Stats[stat]) {
                        rez[f][stat] = Stats[stat](values);
                    }
                });

            }

            return typeof arr_or_string === "string" ? rez[arr_or_string] : rez;
        },
        writable: true,
    },

    /**
     * pt colectii in care am dt_in si dt_out
     *  pt arr_obj --> TE.assoc("activitati_sub").aggregate_dates("dt_in","dt_out") sau  pt arr_arr --> TE.data.activitati_sub.aggregate_dates(3,4)
     */
    aggregate_dates: {
        value: function (c1, c2) {
            var min = null,
                max = null,
                intv_min = null,
                intv_max = null,
                bugs = false,
                first,
                last,
                long,
                short;
            this.map((s) => {
                if (s[c1] && s[c2]) {
                    var d1 = new Date(s[c1]),
                        d2 = new Date(s[c2]);
                    if (min === null || d1 < min) {
                        min = d1;
                        first = s;
                    }
                    if (max === null || d2 > max) {
                        max = d2;
                        last = s;
                    }
                    var intv = Date.days_between(d1, d2);
                    if (intv_min === null || intv_min > intv) {
                        intv_min = intv;
                        short = s;
                    }
                    if (intv_max === null || intv_max < intv) {
                        intv_max = intv;
                        long = s;
                    }
                } else {
                    bugs = true;
                }
            });
            return {
                in: min.date,
                out: max.date,
                intv: min.days_to(max),
                min: intv_min,
                max: intv_max,
                first,
                last,
                long,
                short,
                bugs,
            };
        }, writable: true,
    },
    select: {
        /**
         * ex: SED.activitati_buget.select("descriere AS desc,ref_id,id AS id_chelt,cod_chelt AS cc,flag_am AS F,val_tot,tva_tot,val_elig,tva_elig,val_neramb", TE.columns.activitati_buget);
         *
         * daca am array of objects nu e nevoie sa pasez c_names pt ca se deduce din primul obiect din array    ex TE.assoc('activitati').select(["is AS act_id","den act_den"])
         *
         * @param {type} q
         * @param {type} c_names
         * @returns {Array}
         */
        value: function (q, c_names) {
            if (!this.length || !q) {
                return [];
            }
            var C = {},
                rez = [],
                OBJ = false;
            if (!Array.isArray(this[0])) {
                // array of objects COLLECTION
                c_names = Object.keys(this[0]);
                OBJ = true;
            }
            if (typeof q !== "string") {
                q = q.join(",");
            }
            q.replace(/\sAS\s/gim, " ")
                .replace(/\s{2,}/gim, " ")
                .split(",")
                .map((s) => {
                    s = s.trim();
                    var idx_ = s.indexOf(" "),
                        k,
                        v;
                    if (idx_ >= 0) {
                        (k = s.substr(0, idx_)), (v = s.substr(idx_ + 1).replace(/['"]/gim, "") || k);
                    } else {
                        k = v = s;
                    }
                    C[v] = OBJ ? k : c_names.indexOf(k);
                });
            this.map((set) => {
                var o = {};
                for (var p in C) {
                    o[p] = set[C[p]];
                }
                rez.push(o);
            });

            return rez;
        },
        writable: true,
    },
    left_join: {
        /**
         * example:
         *  A = [{a: 1, b: 1, c: 1}, {a: 2, b: 2, c: 2},{a:555,b:44,c:88}];
         B = [{a: 1, ref: 1, s: 3}, {a: 2, ref: 1, s: 4}, {a: 3, ref: 2, s: 555}];
         A.left_join(B,'ref:a',{a:"id_chelt"}   -->    [{a: 1, b: 1, c: 1, id_chelt: 1, s: 3},...   {a: 555, b: 44, c: 88, id_chelt: null, s: null}]
         * 
         * 
         * 
         * @param {type} arr
         * @param {type} str -- se foloseste css notation ca sa faca B_set.ref = A_set.a conditia de imperechere 
         * -- ATENTIE judec ca alipirea  lui B la A   adica  in stringul "ttt:p1" am coloana ttt in B si vreau sa fie egala cu p1 din A
         * --  se poate face inperecherea dupa mai multe coloane "B.a:A.a;B.ref:A.a;"
         * @param {type} mask  -- redenumirea proprietatilor din B  -->   {a:'a_din_B'}  B_set.a devine B.a_din_B    
         * @returns {BAC_COREAnonym$14.left_join|Array}
         */
        value: function (arr, str, mask = {}) {
            if (!arr.length || !this.length) {
                return this;
            }
            // check properties colision
            for (var p in this[0]) {
                if (arr[0].hasOwnProperty(p)) {
                    if (!mask.hasOwnProperty(p) || this[0].hasOwnProperty(mask[p])) {
                        mask[p] = "_R_." + p;
                        //throw "'" + p + "' property collision in Array.left_join";
                    }
                }
            }
            var rez = [],
                ON = str.s2o;
            this.map((a) => {
                var i = 0;
                arr.map((b) => {
                    for (var c in ON) {
                        if (b[c] != a[ON[c]]) {
                            return;
                        }
                    }
                    var o = a.raw_copy();
                    for (var p in b) {
                        if (!ON.hasOwnProperty(p)) {
                            // elimin din RIGHT coloana pe care s-a facut imperecherea
                            o[mask[p] || p] = b[p];
                        }
                    }
                    rez.push(o);
                    i++;
                });
                if (!i) {
                    var o = a.raw_copy();
                    for (var p in arr[0]) {
                        if (!ON.hasOwnProperty(p)) {
                            o[mask[p] || p] = null;
                        }
                    }
                    rez.push(o);
                }
            });
            return rez;
        }, writable: true,
    },
    crop_sets: {
        // array of objects - la care ma intereseaza numai anumite proprietati coloane
        value: function (cols_of_interest, unique) {
            var cols = typeof cols_of_interest === "string" ? cols_of_interest.split(",") : cols_of_interest;
            var rez = this.map(function (set, idx) {
                var o = {};
                for (var p of cols) {
                    if (set.hasOwnProperty(p)) {
                        o[p] = set[p];
                    }
                }
                // for (var p in set) {
                //     if (cols.indexOf(p) >= 0) {
                //         o[p] = set[p];
                //     }
                // }
                return o;
            });
            return unique ? rez.unique(1) : rez; // ?? BAC e f lenta
        }, writable: true,
    },
    dict: {
        // EX: [{id:1,den:'abc',expl:''},{id:2,den:"def",expl:'...'}].dict("id",den) -> {1:"abc",2:"def"}
        value: function (keyField, valueField) {
            return this.reduce((acc, item) => {
                if (item[keyField] !== undefined && item[valueField] !== undefined) {
                    acc[item[keyField]] = item[valueField];
                }
                return acc;
            }, {});
        }, writable: true,
    },
    match: {
        value: function (prop, rgx) {
            var r = [];
            this.map((s) => {
                rgx.test(s[prop]) && r.push(s);
            });
            return r;
        },
    },
    to_table: {
        value: function (as_dom, transpose, noHead) {
            if (!this.length) {
                return as_dom ? _E("table") : "<table></table>";
            } else {
                var str;
                if (transpose) {
                    let A = this,
                        C = Object.keys(A[0]),
                        T = C.map(c => [c]);
                    // NC = A.length,
                    // NR = C.length;
                    A.map((s, sidx) => {
                        C.map((c, cidx) => {
                            T[cidx][sidx + 1] = s[c];
                        }
                        );
                    }
                    );
                    str = "<table simple transposed>";
                    T.map(r => {
                        let tr = "<tr>";
                        r.map((v, i) => {
                            tr += !i ? "<th>" + v + "</th>" : "<td>" + (v + '' == 'null' ? '' : v) + "</td>"
                        }
                        );
                        tr += "</tr>"
                        str += tr;
                    }
                    );
                    str += "<table>"
                }
                else {
                    var str = noHead ? "<table simple noHead><tbody>" : "<table simple><thead>" + this[0].trh() + "</thead><tbody>";
                    this.forEach(function (set) {
                        str += set.trd();
                    });
                    str += "</tbody></table>";
                }
                return as_dom ? _E(str) : str;
            }
        },
    },
    to_select: {
        value: function (as_dom) {
            var G = _E("select");
            G._(_E("<option value=''>&nbsp;</option>"));
            this.map(val => {
                G._(_E(`<option value=${val}>${val}</option>`));
            });
            return as_dom ? G : G.outerHTML;
        }
    },
    tail: {
        // array of objects all extending with properties given asanother object
        value: function (obj, copy) {
            var tg = copy ? this.raw_copy() : this;
            tg.map(function (set) {
                set.tail(obj);
            });
            return tg;
        },
    },
    collect_prop: {
        // array OF objects
        value: function (c_name) {
            return this.map((set) => set[c_name]);
        },
    },
    collect_index: {
        value: function (c) {
            return this.collect_prop(c);
        },
    },
    pivot: {
        value: function (c_name, preserve_order = false) {
            // array of objects --> intoarce un obiect traversabil dupa c_name  --- daca nu am valori unice obiectele sunt colectate in array 
            // utila mai ales pt adresarea obiecteleor dupa valoarea unui parametru unic 
            var rez = preserve_order ? new Mapo : {};
            for (var s in this) {
                let val = this[s][c_name];
                if (rez.hasOwnProperty(val)) {
                    if (!Array.isArray(rez[val])) {
                        rez[val] = [rez[val]];
                    }
                    rez[val].push(this[s]);
                } else {
                    rez[val] = this[s];
                }
            }
            return rez;
        },
    },



    /** 
     * @return OBJECT-SELF-ORDERED
     * 
     * EX A=[{A:1,B:2,C:3},{A:2,B:3,C:1},{A:3,B:1,C:2},{A:1,B:2,C:1},{A:1,B:1,C:1},{A:3,B:1,C:1}]
     *
     *    A.order_by({A:0,B:0,C:1})  0 <=> asc  1 <=> desc
     */
    order_by: {
        value: function (prop, desc, type) {
            if (gettype(prop) === "Object") {// {col1:false,col2:true} --- order col1 ascending then col2 descending
                var k = Object.keys(prop).reverse();
                k.map((col) => this.order_by(col, prop[col]));
                return this;

            }
            var F = desc ? -1 : 1, A, B;
            this.sort(function (a, b) {
                if (type) {
                    A = Q.float0(a[prop].replace(/<\\?.*?>/gim, ''));
                    B = Q.float0(b[prop].replace(/<\\?.*?>/gim, ''));
                } else {
                    A = typeof a[prop] === 'string' ? a[prop].toUpperCase() : a[prop]; // ignore upper and lowercase
                    B = typeof b[prop] === 'string' ? b[prop].toUpperCase() : b[prop]; // ignore upper and lowercase
                }
                if (A === null) { A = '' }
                if (B === null) { B = '' }
                if (A < B) {
                    return -1 * F;
                }
                if (A > B) {
                    return 1 * F;
                }
                return 0;
            });
            return this;
        }, writable: true,
    },


    // 1 COLUMN ONLY  diferit de  Array.prototype.order_by
    sort_by: {
        value: function (c_idx, desc) {
            // ordoneasa colectie[] de  obj sau arr de form  ex :   o = [{a: 1, b: 6, c: 55}, {a: 3, b: 4, c: 2}];  o.recursive_swap(['b','c'] )   - in ordinea  b si c
            if (Array.isArray(c_idx)) {
                c_idx.map((c) => this.sort_by(c, desc));
                return this;
            } else {
                var SW = 0,
                    BUF;
                for (var i = 0; i < this.length - 1; i++) {
                    var _a = this[i][c_idx],
                        _b = this[i + 1][c_idx],
                        a,
                        b;
                    a = +_a;
                    if (!a) {
                        a = Q.fromRoman(_a);
                    }
                    a = a ? a : _a || null;
                    b = +_b;
                    if (!b) {
                        b = Q.fromRoman(_b);
                    }
                    b = b ? b : _b || null;
                    var cond = desc ? a < b : a > b;
                    if (cond) {
                        BUF = this[i + 1];
                        this[i + 1] = this[i];
                        this[i] = BUF;
                        ++SW;
                    }
                }
                return SW ? this.sort_by(c_idx) : this;
            }
        }, writable: true,
    },

    sort_mixed: {
        value: function () {
            var O = [],
                N = [],
                L = [];
            this.forEach((e) => {
                e === null ? O.push(e) : Number.isFinite(e) ? N.push(e) : L.push(e);
            });
            N.sort((a, b) => a - b);
            L.sort();
            [...O, ...N, ...L].forEach((v, i) => (this[i] = v));
            return this;
        },
    },
    data_group: {
        value: function (arr, prop, l_name, r_name) {
            l_name = l_name || "L";
            r_name = r_name || "R";
            var rez = {};
            for (var s in this) {
                rez[this[s][prop]] = {};
                rez[this[s][prop]][l_name] = this[s];
            }
            for (var v in arr) {
                console.log(rez[arr[v][prop]], arr[v][prop]);
                if (rez[arr[v][prop]]) {
                    rez[arr[v][prop]][r_name] = arr[v];
                } else {
                    //rez[this[v][prop]] = {};
                    //rez[arr[v][prop]][r_name] = arr[v];
                }
            }
            return rez;
        },
    },
    /**
     *  un array of objects care pot avea citeva proprietati
     *  daca arg este string
     * [{a:1,b:1},{a:1,b:2},,{a:2,b:1}].group_by("a")  -->  {"1":[{"a":1,"b":1},{"a":1,"b":2}],"2":[{"a":2,"b":1}]}
     *
     *  daca arg este arrray cu un singur element
     *  [{a:1,b:1},{a:1,b:2},,{a:2,b:1}].group_by(["a"]) -->  [{"a":1,"group":[{"b":1},{"b":2}]},{"a":2,"group":[{"b":1}]}]
     *
     *  daca am array cu mai multe elemente
     *  try this  Q.i([{a:1,b:1,c:3},{a:1,b:2},,{a:2,b:1},{a:1,b:1,c:444}].group_by(["a","b"]))
     *
     */
    group_by: {
        value: function (arg) {
            var q = {},
                $ = this;
            if (typeof arg === "string") {
                this.forEach(function (set, idx) {
                    var prop = set[arg];
                    if (!q.hasOwnProperty(prop)) {
                        q[prop] = [];
                    }
                    q[prop].push(set);
                });
                return q;
            } else {
                this.forEach(function (set, idx) {
                    var label = "",
                        grp = {};
                    arg.forEach(function (p) {
                        label += set[p];
                        grp[p] = set[p];
                    });
                    if (!q.hasOwnProperty(label)) {
                        grp.group = [];
                        q[label] = grp;
                    }
                    var o = {};
                    for (var p in set) {
                        if (!arg.has(p)) {
                            o[p] = set[p];
                        }
                    }
                    q[label].group.push(o);
                });
                return q.values();
            }
        },
    },
    sum: {
        value: function () {
            var rez = 0;
            this.map(function (elm) {
                rez += parseFloat(elm);
            });
            return rez;
        },
    },
    float: {
        value: function () {
            return this.map(function (elm) {
                return parseFloat(elm);
            });
        },
    },
    trim: {
        // trim ol elements of an array
        value: function () {
            for (var i in this) this[i] = this[i] ? String.prototype.trim.call(this[i]) : this[i];
            return this;
        },
    },
    /**
     *  [{A:1,B:2},{A:3,B:4}].tabular_object() => {cols:["A","B"],vals:[[1,2],[3,4]]}
     */
    tabular_object: {
        value: function () {
            var o = {};
            if (this.length === 0) {
                o.cols = [];
                o.vals = [];
            } else {
                o.cols = this[0].pkeys();
                o.vals = this.map(function (set) {
                    return set.values();
                });
            }
            return o;
        },
    },
    /**
     * COLLECTION = array of  objects (same pkeys)
     * ["A","B"].combine_to_collection([[1,2],[3,4]]) => [{A:1,B:2},{A:3,B:4}]
     */
    combine_to_collection: {
        value: function (sets_arr) {
            var rez = [];
            for (var v in sets_arr) {
                var o = [].combine(this, sets_arr[v]);
                rez.push(o);
            }
            return rez;
        },
    },
    dump_csv: {
        value: function (arg) {
            var is_object = gettype(this[0]) === "Object" ? true : false,
                csv_str = is_object && arg ? this[0].pkeys().join() + "\n" : typeof arg === "object" ? arg.join() + "\n" : "";
            this.forEach(function (set, idx) {
                csv_str += '"' + (is_object ? set.values().trim() : set.trim()).esc_csv_quot().join('","') + '"\n';
            });
            var t = csv_str.replace(/<\/?.*?>/gims, "").replace(/&nbsp;/gims, "");
            return t;
        },
    },
    load_csv: {
        value: function (text, as_collection) {
            // https://stackoverflow.com/posts/41563966/revisions
            // return (function csvToArray(text) {
            let p = "",
                row = [""],
                ret = [row],
                i = 0,
                r = 0,
                s = !0,
                l;
            for (l of text) {
                if ('"' === l) {
                    if (s && l === p) row[i] += l;
                    s = !s;
                } else if ("," === l && s) l = row[++i] = "";
                else if ("\n" === l && s) {
                    if ("\r" === p) row[i] = row[i].slice(0, -1);
                    row = ret[++r] = [(l = "")];
                    i = 0;
                } else row[i] += l;
                p = l;
            }
            if (as_collection) {
                let c_names = ret.shift();
                return c_names.combine_to_collection(ret);
            } else {
                return ret;
            }
        },
    },
    as_select: {
        value: function (add_null) {
            var select = _E("select");
            add_null && select._("<option value=''>&nbsp;</option>");
            for (var i = 0; i < this.length; i++) {
                var o = _E("option", this[i]);
                o.value = this[i];
                select._(o);
            }
            return select;
        },
    },
    esc_csv_quot: {
        value: function () {
            return this.map(function (elm) {
                return (elm + "").replace(/"/gim, '""');
            });
        },
    },
    //[1,2,3].combinations(2) => [ [1,2], [1,3], [2,3]   ]    --  de testat comb(5,2)
    combinations: {
        value: function (k) { // recursive method
            if (k > this.length || k <= 0 || k === undefined) {
                return [];
            }
            if (k === this.length) {
                return [this];
            }
            const combs = [];
            if (k === 1) {
                for (let i = 0; i < this.length; i++) {
                    combs.push([this[i]]);
                }
                return combs;
            }
            for (let i = 0; i < this.length - k + 1; i++) {
                const head = this.slice(i, i + 1);
                const tailcombs = this.slice(i + 1).combinations(k - 1);
                for (let j = 0; j < tailcombs.length; j++) {
                    combs.push(head.concat(tailcombs[j]));
                }
            }
            return combs;
        },
    },
    test: {
        // testarea ca un string raspunde la cel putin o conditie din this_array
        value: function (str) {
            var r = new RegExp(this.join("|"), "gim");
            return r.test(str);
        },
    },
    has_duplicates: {
        value: function () {
            return new Set(this).size !== this.length;
        },
    },
    get_duplicates: {
        value: function () {
            const seen = new Set();
            const duplicates = new Set();
            for (const item of this) {
                if (seen.has(item)) {
                    duplicates.add(item);
                } else {
                    seen.add(item);
                }
            }
            return Array.from(duplicates);
        }
    },
    nth: {
        /**
         * @example | [1,2,3].nth(-1) -> 3 last_element
         * @param {nuber} n
         * @returns {element}
         */
        value: function (n) {
            return (n > 0 ? this.slice(n, n + 1) : this.length + n < 0 ? [] : this.slice(n))[0];
        },
    },
    move: {
        value: function (from, to) {
            this.splice(to, 0, this.splice(from, 1)[0]);
            return this;
        }
    },
    operate: {
        value: function (B, key) {
            var A = this;
            const get = key
                ? x => x[key]
                : x => (typeof x === "object" ? JSON.stringify(x) : x);
            const a = new Map(A.map(x => [get(x), x]));
            const b = new Map(B.map(x => [get(x), x]));
            return {
                A_minus_B: A.filter(x => !b.has(get(x))),
                B_minus_A: B.filter(x => !a.has(get(x))),
                intersection: A.filter(x => b.has(get(x))),
                union: [...new Map([...A, ...B].map(x => [JSON.stringify(x), x])).values()]
            };
        }
    }
});


const Stats = {
    min: (arr) => Math.min(...arr),

    max: (arr) => Math.max(...arr),

    sum: (arr) => arr.reduce((acc, val) => acc + val, 0),

    avg: (arr) => arr.length ? Stats.sum(arr) / arr.length : null,

    median: (arr) => { // Middle value in sorted list      
        const sorted = [...arr].sort((a, b) => a - b);
        const mid = Math.floor(sorted.length / 2);
        return arr.length % 2 === 0
            ? (sorted[mid - 1] + sorted[mid]) / 2
            : sorted[mid];
    },

    mode: (arr) => {//  Most frequently occurring value(s) 
        const freq = {};
        let max = 0, modes = [];
        for (const val of arr) {
            freq[val] = (freq[val] || 0) + 1;
            if (freq[val] > max) {
                max = freq[val];
                modes = [val];
            } else if (freq[val] === max) {
                modes.push(val);
            }
        }
        return [...new Set(modes)];
    },

    stddev: (arr) => { // Standard deviation (spread of values) 
        const mean = Stats.avg(arr);
        const variance = arr.reduce((acc, val) => acc + (val - mean) ** 2, 0) / arr.length;
        return Math.sqrt(variance);
    },

    variance: (arr) => { // square of standard deviation
        const mean = Stats.avg(arr);
        return arr.reduce((acc, val) => acc + (val - mean) ** 2, 0) / arr.length;
    },

    range: (arr) => Stats.max(arr) - Stats.min(arr), //  Difference between max and min  

    q1: (arr) => Stats.quantile(arr, 0.25),

    q3: (arr) => Stats.quantile(arr, 0.75),

    iqr: (arr) => Stats.q3(arr) - Stats.q1(arr),

    count: (arr) => arr.length,

    distinct: (arr) => new Set(arr).size,

    quantile: (arr, q) => {  // 1st quartile, 3rd quartile, interquartile range
        const sorted = [...arr].sort((a, b) => a - b);
        const pos = (sorted.length - 1) * q;
        const base = Math.floor(pos);
        const rest = pos - base;
        return sorted[base] + rest * ((sorted[base + 1] ?? sorted[base]) - sorted[base]);
    }
};


NLP.as1 = Array.prototype.as1;

Object.defineProperties(Number.prototype, {
    locale: {
        value: function (n = 2) {
            return this.toLocaleString("en", {
                minimumFractionDigits: n,
                maximumFractionDigits: n,
            });
        },
    },
    roman: {
        get: function () {
            if (isNaN(this)) return NaN;
            var num = this;
            var roman = {
                M: 1000,
                CM: 900,
                D: 500,
                CD: 400,
                C: 100,
                XC: 90,
                L: 50,
                XL: 40,
                X: 10,
                IX: 9,
                V: 5,
                IV: 4,
                I: 1,
            };
            var str = "";
            for (var i of Object.keys(roman)) {
                var q = Math.floor(num / roman[i]);
                num -= q * roman[i];
                str += i.repeat(q);
            }
            return str;
        },
    },
    precision: {
        value: function (n = 2, flag = 'round') {
            const factor = 10 ** n;
            const x = (Q.float0(this) + Number.EPSILON) * factor;
            return Q.float0((PREC_OP[flag] || Math.round)(x) / factor);
        }
    }
});
const PREC_OP = {
    round: Math.round,
    ceil: Math.ceil,
    floor: Math.floor
};
function precision(v, p = 2) {
    return parseFloat((parseFloat(v) || 0).toFixed(p));
}

Object.defineProperty(Number.prototype, 'humanFileSize', {
    value: function (a, decimals = 2, b, c, d) {
        return (a = a ? [1e3, 'k', 'B'] : [1024, 'K', 'iB'], b = Math, c = b.log, d = c(this) / c(a[0]) | 0, this / b.pow(a[0], d)).toFixed(decimals) + ' ' + (d ? (a[1] + 'MGTPEZY')[--d] + a[2] : 'Bytes');
    }, writable: false, enumerable: false
});

function camelize(str) {
    var a = str.split("-");
    if (a[0] === "") a.shift();
    var rez = a[0];
    for (var i = 1; i < a.length; i++) rez += a[i].capitalize();
    return rez;
}

function if_brac(s) {
    return DOC.style[s] === undefined ? "-" + BRAC + "-" + s : s;
}

Node.prototype.css = function (s) {
    if (typeof s === "object") {
        this.style.cssText += ";" + s.o2s();
    } else {
        switch (s) {
            case "#":
                return;
            case undefined:
                return this.style.cssText;
            case "":
                this.style.cssText = null;
                break;
            default:
                this.style.cssText += ";" + s;
        }
    }
    return this;
};
Node.prototype.import_style = function (str) {
    console.log(this);
    this._(_E("style", `@import url(${str})`));
};

Element.prototype.computed = function (a, pseudo) {
    // ??? BUBA
    return a ? getComputedStyle(this, pseudo)[a] : getComputedStyle(this, pseudo);
};

/* POSITION & DIMENDIONS
 *****************************************************/
function getY(e) {
    var o = 0;
    while (e) {
        o += e.offsetTop;
        e = e.offsetParent;
    }
    return o;
}

function getX(e) {
    var o = 0;
    while (e) {
        o += e.offsetLeft;
        e = e.offsetParent;
    }
    return o;
}

Object.defineProperties(EP, {
    _cache_: {
        value: null,
        writable: true,
        configurable: true,
    },
    cache: {
        // ideea e sa masor doar o data si sa notez dupa ultima stare  --- avoid reflow and repaint  for repeated animations
        get: function () {
            // !!!BAC>>> nu arrow function
            var $ = this;
            if (!$._cache_) {
                $._cache_ = new Proxy(
                    {},
                    {
                        get: function (o, p) {
                            if (!o.hasOwnProperty(p)) {
                                // !!!BAC  1level object  vs Pointer
                                o[p] = $[p];
                            }
                            return o[p];
                        },
                        set: function (o, p, v) {
                            o[p] = v;
                            $[p] = v;
                        },
                    }
                );
            }
            return $._cache_;
        },
    },
    cr: {
        get: function () {
            // !!!!!!!!!!! NASOL CU PAGE REFLOW
            let O = this.getBoundingClientRect();
            Object.defineProperties(O, {
                page_x: {
                    get: function () {
                        return this.x + window.scrollX
                    }
                },
                page_y: {
                    get: function () {
                        return this.y + window.scrollY
                    }
                }
            })
            return O
        },
        enumerable: true,
    },
    x: {
        // !!!????  CONFLICT CU SVG
        get: function () {
            return this.cr.left + (document.scrollingElement.scrollLeft || 0); //getX(this);
        },
        set: function (x) {
            this.style.left = x + "px";
        },
        enumerable: true,
    },
    y: {
        get: function () {
            //return getY(this);
            return this.cr.top + (document.scrollingElement.scrollTop || 0); // buba la chrome 6.1
        },
        set: function (y) {
            this.style.top = y + "px";
        },
        enumerable: true,
    },
    z: {
        get: function () {
            return this.computed("z-index");
        },
        set: function (val) {
            this.style.zIndex = val;
        },
        enumerable: true,
    },
    w: {
        get: function () {
            return this.cr.width;
        },
        set: function (val) {
            this.style.width = val + "px";
        },
        enumerable: true,
    },
    h: {
        get: function () {
            return this.cr.height;
        },
        set: function (val) {
            this.style.height = val + "px";
        },
        enumerable: true
    },
    matrix: {
        get: function () {
            var M = this.computed()
                .transform.split(/\s*[(),]\s*/)
                .slice(1, -1); // matrix(0,1,....  string
            if (!M.length) M = [1, 0, 0, 1, 0, 0];
            if (M.length === 6) {
                M = [M[0], M[1], 0, 0, M[2], M[3], 0, 0, 0, 0, 1, 0, M[4], M[5], 0, 1];
            }
            return M.map((i) => +i);
        },
        set: function (M) {
            //requestAnimationFrame(() => this.style.transform = "matrix3d(" + M.join(",") + ")");
            this.style.transform = "matrix3d(" + M.join(",") + ")";
        },
    },
    mtx: {
        get: function () {
            return new Proxy(this, {
                get(o, p) {
                    // read any position in the elementmatrix
                    switch (true) {
                        case Number.isInteger(p):
                            return o.matrix[p];
                            break;
                        case p === "reset":
                            return function () {
                                o.matrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
                                //o.style.transform="";
                                delete o.active_trans; // e nevoie in  BAC_MORF
                                return o;
                            };
                            break;
                    }
                },
                set(o, p, v) {
                    // modify any position in matrix
                    var n = parseInt(p);
                    if (Number.isInteger(n) && 0 <= n <= 15) {
                        var A = o.matrix;
                        A[p] = v;
                        o.matrix = A;
                    } else {
                        switch (p) {
                            case "txy":
                                var A = o.matrix;
                                A[12] = v[0];
                                A[13] = v[1];
                                o.matrix = A;
                                break;
                            case "scale":
                                var A = o.matrix;
                                A[0] = A[5] = v;
                                o.matrix = A;
                                break;
                            default:
                                var tp = {
                                    r0c0: 0,
                                    r0c1: 1,
                                    r0c2: 2,
                                    r0c3: 3,
                                    r1c0: 4,
                                    r1c1: 5,
                                    r1c2: 6,
                                    r1c3: 7,
                                    r2c0: 8,
                                    r2c1: 9,
                                    r2c2: 10,
                                    r2c3: 11,
                                    r3c0: 12,
                                    r3c1: 13,
                                    r3c2: 14,
                                    r3c3: 15,
                                }[p];
                                if (tp >= 0) {
                                    o.mtx[tp] = v;
                                }
                                break;
                        }
                    }
                },
            });
        },
        set: function (M) {
            // 3d only
            this.matrix = M;
        },
    },
    txy: {
        get: function () {
            var M = this.matrix;
            return [M[12], M[13]];
        },
        set: function (arr) {
            var M = this.matrix;
            M[12] = parseFloat(arr[0]);
            M[13] = parseFloat(arr[1]);
            this.matrix = M;
        },
    },
    __txy: {
        get: function () {
            var M = this.cache.matrix;
            return [M[12], M[13]];
        },
        set: function (arr) {
            var M = this.cache.matrix;
            M[12] = parseFloat(arr[0]);
            M[13] = parseFloat(arr[1]);
            this.cache.matrix = M;
        },
    },
    __scale2d: {
        //  cache 2D scaling
        get: function () {
            return this.cache.matrix[0];
        },
        set: function (s) {
            var M = this.cache.matrix;
            M[0] = M[5] = parseFloat(s);
            this.cache.matrix = M;
        },
    },
    __matrix: {
        get: function () {
            return this.cache.matrix;
        },
        set: function (M) {
            this.cache.matrix = M;
        },
    },
    trsl: {
        get: function () {
            var EXEC = /translate\(([-\d\.]+).*?([-\d\.]+).*?\)/.exec(this.style.transform) || [null, 0, 0];
            return { tx: parseFloat(EXEC[1]), ty: parseFloat(EXEC[2]) };
        },
    },
    tx: {
        get: function () {
            return parseFloat(this.matrix[12]);
        },
        set: function (x) {
            var M = this.matrix;
            M[12] = parseFloat(x);
            this.matrix = M;
        },
    },
    ty: {
        get: function () {
            return parseFloat(this.matrix[13]);
        },
        set: function (y) {
            var M = this.matrix;
            M[13] = parseFloat(y);
            this.matrix = M;
        },
    },
    oxy: {
        get: function () {
            return (this.computed().transformOrigin || "").match(/[\.-\d]+/gim);
        },
        set: function (arr) {
            this.style.transformOrigin = `${arr[0]}px ${arr[1]}px`;
        },
    },
    ox: {
        get: function () {
            return this.oxy[0];
        },
        set: function (x) {
            this.oxy = [x, this.oxy[1]];
        },
    },
    oy: {
        get: function () {
            return this.oxy[1];
        },
        set: function (y) {
            this.oxy = [this.oxy[0], y];
        },
    },
    geometry: {
        get: function () {
            // 2 dimension
            var $ = this,
                cr = $.cr, // client rects
                comp = $.computed(), // getComputedStyle($)
                MTX, // matrix(0,1,....  string
                trfo = (comp.transformOrigin || "").match(/[\.-\d]+/gim), // transform origin
                scale,
                M = comp.transform.split(/\s*[(),]\s*/).slice(1, -1); // matrix(0,1,....  string
            if (!M.length) M = [1, 0, 0, 1, 0, 0];
            if (M.length === 6) {
                M = [M[0], M[1], 0, 0, M[2], M[3], 0, 0, 0, 0, 1, 0, M[4], M[5], 0, 1];
            }
            MTX = M.map((i) => +i);
            trfo = trfo ? trfo.map((i) => +i) : [0, 0];
            scale = Math.sqrt(MTX[0] * MTX[0] + MTX[1] * MTX[1]);
            return {
                matrix: MTX,
                //"computed.transform": comp.transform,
                //"style.transform": $.style.transform,
                scale: scale,
                rotateY: -Math.rad2deg(Math.asin(-M[8])), //flip
                rotateX: -Math.rad2deg(Math.atan(M[9] / M[10])), // roll
                rotateZ: -Math.rad2deg(Math.atan(M[4] / M[0])), //spin
                tx: MTX[12],
                ty: MTX[13],
                tz: MTX[14],
                x: cr.x,
                y: cr.y,
                w: cr.width,
                h: cr.height,
                top: cr.top + (document.scrollingElement.scrollTop || 0), // ???BAC offsetParent
                left: cr.left + (document.scrollingElement.scrollLeft || 0),
                bottom: cr.bottom,
                right: cr.right,
                ox: trfo[0],
                oy: trfo[1],
            };
        },
    },
});

// MUTATION OBSERVER
// var config = { attributes: true, childList: true, characterData: true };
EP.reflect = function (config, reaction) {
    this.reflect_off();
    var o = new MutationObserver(reaction);
    this.observer = o;
    o.target = this;
    if (!Object.keys(config).length) config = { attributes: true, childList: true, characterData: true };
    o.observe(this, config);
    return this;
};
EP.reflect_off = function () {
    if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
    }
};

EP.expand_dom_above = function () {
    // <elm minimized>...</elm>  --- use ATTRIBUTE
    var p = this.parent;
    while (p && p !== document.body) {
        p.removeAttribute("minimized");
        p = p.parentNode;
    }
    this.fire("expand_dom_above");
    return this;
};

// pozitionarea elementului la vedere la undo redo
if (!EP.scrollIntoViewIfNeeded) {
    EP.scrollIntoViewIfNeeded = function () {
        return this.scrollIntoView();
    };
}
// BAC!!!
EP.scroll2view = function (options) {
    // BAC!!! mare consumator de resurse ---  mai ales la undo_all sau redo_all ---  trebuie reparat
    var $ = this,
        tabs_panel = $.closest("[tabs_panel]"),
        onoffed = $.closest("[onoffed]");
    tabs_panel && !tabs_panel.hasA("active") && tabs_panel.btn.click(); // selectarea tabului pe care se afla inputul modificat
    onoffed && onoffed.btn?.hasA("colapsed") && onoffed.btn.click(); // deschiderea onoff daca e cumva inchis
    $.expand_dom_above();
    setTimeout(() => {
        $.scrollIntoViewIfNeeded(options); // nu  merge   $.scrollIntoView
    }, 0);

    return this;
};


var AUTO_RESIZE_OFFSET = 1; // 0 ar trebui da masoara ciudat

EP.auto_resize_height = function () {
    var elm = this;
    setTimeout(function () {
        elm.style.height = "auto";
        var h = elm.scrollHeight
        elm.style.height = (h + (h > 26 ? AUTO_RESIZE_OFFSET : 0)) + "px"; // +1 -- apare scroll ??? nu inteleg cum masoara // BUG:
    }, 0);
};

EP.resize_inner_textareas_height = function () {
    var $ = this;
    setTimeout(function () {
        $.find("textarea").map(inp => {
            inp.auto_resize_height();
            //if (inp.name === "IP_PRF") { console.trace(inp, inp.value); }
        });
    }, 1);
};

EP.set_cursor_poz = function (pos) {
    pos = pos === "last" ? this.value.length : pos;
    //this.fire('focus');
    if (this.setSelectionRange) {
        this.setSelectionRange(pos, pos);
    } else if (this.createTextRange) {
        var range = this.createTextRange();
        range.collapse(true);
        range.moveEnd("character", pos);
        range.moveStart("character", pos);
        range.select();
    }
    return this;
};

Object.defineProperties(Element.prototype, {
    xpath: {
        get: function () {
            var $ = this;
            if (typeof $ === "string") return document.evaluate($, document, null, 0, null);
            if (!$ || $.nodeType !== 1) return "";
            if ($.id) return "//*[@id='" + $.id + "']";
            var sames = [].filter.call($.parentNode.children, function (x) {
                return x.tagName === $.tagName;
            });
            return $.parentNode.xpath + "/" + $.tagName.toLowerCase() + (sames.length > 1 ? "[" + ([].indexOf.call(sames, $) + 1) + "]" : "");
        },
    },
    get_by_xpath: {
        //https://developer.mozilla.org/en-US/docs/Web/API/Document/evaluate
        value: function (path) {
            return document.evaluate(path, this, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
        },
    },
});


Object.defineProperty(EP, "has_value", {
    get: function () {
        let $ = this;
        return new Promise((done, fail) => {
            if ($.value) {
                done($.value)
            } else {
                $.once("change", (ev) => {
                    if ($.value) {
                        done($.value);
                        ev.stopPropagation();
                    }
                });
                Q.validate($.parent);
            }
        })
    },
    enumerable: true
})


// genereaza asociaza id pt un element care nu are -- !!!ATENTIE !!!ATENTIE ---- POOATE RUPE CHESTII LA EDIT
Q.dinIdContor = 0;
Q.dinId = function (elm, opt = {}) {
    if (!elm) return "dinId" + Q.dinIdContor++;
    if (!elm.id) {
        elm.id = (opt.prefix || "") + "dinId" + Q.dinIdContor++ + (opt.sufix || "");
    }
    return elm.id;
};

Q.random = function () {
    return (Math.random() * 1e39).toString(Math.ceil(Math.random() * 30) + 2);
};

Q.random_color = function (opacity) {
    return "rgba(" + parseInt(Math.random() * 200 + 50) + "," + parseInt(Math.random() * 150 + 50) + "," + parseInt(Math.random() * 150 + 50) + "," + (opacity || 1) + ")";
};
/**
 * atentie presupune reprezentarea localeString(EN) --- adica am 123,334.00
 
 * @param {type} value
 * @returns {Number} */
Q.float0 = function (value) {
    return parseFloat(typeof value === "string" ? value.replace(/,/g, "") : value) || 0;
};
/**
 *
 * @param {*} x
 * @returns value including
 */
Q.db_value = function (x) {
    return x;
    x || x + "" === "0" ? x : null;
};

/**
 *
 * @param {*} x
 * @returns true even if '0'
 */
Q.is_db_value = function (x) {
    return x || x + "" === "0" ? true : false;
};

Q.gshup = function (str, len) {
    return (str + "" || "").gshup(len);
};
Q.un_gshup = function (str) {
    if (/<gshup>/.test(str)) {
        return /<gshup><m>(.*)<\/m>/gis.exec(str)[1].trim();
    } else {
        return str;
    }
};

Q.fromRoman = function (str) {
    var result = 0;
    if (typeof str !== "string") return NaN;
    var decimal = [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1];
    var roman = ["M", "CM", "D", "CD", "C", "XC", "L", "XL", "X", "IX", "V", "IV", "I"];
    for (var i = 0; i <= decimal.length; i++) {
        while (str.indexOf(roman[i]) === 0) {
            result += decimal[i];
            str = str.replace(roman[i], "");
        }
    }
    return str.length ? NaN : result;
};
Q.toRoman = function (nr) {
    if (parseInt(nr) !== nr) return NaN;
    return nr.roman;
};
dinStyle = _E("style").setA("JS_INSERTS").setA("type", "text/css");
Q("head")[0]._(dinStyle);

Object.defineProperty(Object.prototype, "gost", {
    value: function (prop, initial_value) {
        Object.defineProperty(this, prop, {
            value: initial_value,
            writable: true,
        });
        return this;
    },
    configurable: true,
    writable: true,
});

// nu se poate aplica pt propietati DOM ex el.style.width pt ca suprasrie si se pierde functionalitatea implicita
Object.defineProperty(Object.prototype, "trig", {
    value: function (prop, handler, initial_value) {
        Object.defineProperty(this, "_" + prop + "_", {
            value: initial_value,
            writable: true,
        });
        Object.defineProperty(this, prop, {
            enumerable: true,
            configurable: true,
            get: function () {
                return this["_" + prop + "_"];
            },
            set: function (newVal) {
                var oldVal = this["_" + prop + "_"];
                this["_" + prop + "_"] = newVal;
                handler.bind(this)(newVal, oldVal);
            },
        });
        return this;
    },
});



MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;

//scrolling page // IE nu scroleaza body
function scrollPageTo(x, y) {
    var j = 30;
    var xScrollStep = (x - pageXOffset) / j;
    var yScrollStep = (y - pageYOffset) / j;
    var ani = setInterval(function () {
        j === 0 && clearInterval(ani);
        window.scrollBy(xScrollStep, yScrollStep);
        j--;
    }, 20);
}

EP.scrollY = function (poz, cb) {
    var $ = this,
        dt = 30,
        N = 300 / dt;
    cb = !cb ? nf : cb;
    if (poz.has("%")) poz = ($.scrollHeight - $.offsetHeight) * (parseFloat(poz) / 100);
    poz = { top: -1, bottom: $.scrollHeight }[poz] || poz;
    var scrs = (poz - $.scrollTop) / N;
    (function xxx() {
        $.scrollTop += scrs;
        --N >= 0 ? setTimeout(xxx, dt) : cb($);
    })();
};

EP.fix = function (...A) {
    var ar = A[0] ? A : ["height", "width", "top", "left"];
    let COMP = this.computed();
    for (var i = 0; i < ar.length; i++) {
        var u = COMP[ar[i]]; //if(u==''||u==undefined)dn('#'+u);else dn(u);
        this.style[ar[i]] = u === "auto" ? eval("(this.offset" + ar[i].capitalize() + ")+'px'") : u;
    }
    return this;
};

EP.centerW = function () {
    this.css("left:" + (this.parentNode.offsetWidth - this.offsetWidth) / 2 + "px");
    return this;
};

EP.centerH = function () {
    this.css("top:" + (this.parentNode.offsetHeight - this.offsetHeight) / 2 + "px");
    return this;
};
/**
 * 
 
 * @param {type} str
 * @returns {Element.prototype.wrap.w|Node.prototype.wrap.w|$.firstElementChild|document.querySelector@call;bind.firstElementChild|_E.$|Element} 
 * 
 *  !!! nu merge pt input si textarea --- 
 * */
EP.wrap = function (str) {
    var w = _E("");
    w.css("display:inline-block;position:relative");
    if (str !== undefined) w.css(str);
    w.oust(this); //this.replaced(w);
    w._(this);
    this._wrapper_ = w;
    return w;
};
EP.unwrap = function () {
    if (this._wrapper_) {
        let p = this.parent;
        this._before(p);
        //console.log(p, this)
        p.die();
    }
}

EP.pin = function (str) {
    let cmp = this.computed(),
        w = cmp.width,
        h = cmp.height;
    console.log(cmp.width, cmp.height);
    var pin = this.wrap(str);
    pin.css(`width:${w};height:${h}`);
    this.css("position:absolute;top:0;left:0");
    return pin;
};




/* EVENTS
 *****************************************************************/

window.on = window.AEL = window.addEventListener;
window.off = window.REL = window.removeEventListener;
NP.AEL = Element.prototype.addEventListener; // NP adauga AEL si pt document --- EP nu se uita decit la elemente
NP.REL = Element.prototype.removeEventListener;

Object.defineProperties(Event.prototype, {
    path_closest: {
        value: function (tagName) {
            var T = tagName.toUpperCase(),
                path = this.path || this.composedPath(); // mac and ios -> composedPath
            for (var i in path) {
                if (path[i].tagName === T) {
                    return path[i];
                }
            }
        },
    },
    lock: { // !!!BAC>>> nu merge pt inputuri number la sagetile up/down
        value: function () {
            this.stopPropagation();
            this.preventDefault();
            this.target.blur();
        }
    },
    burst: {
        get: function () {
            return window.event_burst ? true : false;
        }
    }
});

!Event.prototype.key &&
    Object.defineProperties(Event.prototype, {
        key: {
            get: function () {
                return this.witch || this.keyCode;
            },
            enumerable: true,
        },
    });

BRAC === "Moz" &&
    Object.defineProperty(Event.prototype, "path", {
        get: function () {
            return this.composedPath();
        },
    });



// MOUSE HOLD EVENT


(function () {
    var holdTimer;
    function hold_event_handler(ev) {
        const tg = ev.target;
        if (tg.tagName === "TEXTAREA") {
            const rect = tg.getBoundingClientRect();
            const inResizeCorner =
                (rect.bottom - ev.clientY < 20) && (rect.right - ev.clientX < 20);
            if (inResizeCorner) return;
        }

        holdTimer = setTimeout(() => {
            tg.fire("hold");
        }, 300);
    }

    function cancel_hold() {
        clearTimeout(holdTimer);
    }

    let _HL_ = false;

    Object.defineProperty(window, "hold_listening", {
        get: () => _HL_,
        set: (val) => {
            if (val && !_HL_) {
                _HL_ = true;
                document.addEventListener("mousedown", hold_event_handler);
                document.addEventListener("touchstart", hold_event_handler);
                document.addEventListener("mouseup", cancel_hold);
                document.addEventListener("touchend", cancel_hold);
            } else if (!val && _HL_) {
                _HL_ = false;
                document.removeEventListener("mousedown", hold_event_handler);
                document.removeEventListener("touchstart", hold_event_handler);
                document.removeEventListener("mouseup", cancel_hold);
                document.removeEventListener("touchend", cancel_hold);
            }
        },
    });

    // Enable by default
    window.hold_listening = true;
})();

/* RESIZE EVENTS */
function trackUserTextareaResize(surface, onResize) {
    let activeTextarea = null;
    let initialSize = null;
    let resized = false;

    const observer = new ResizeObserver(entries => {
        for (const entry of entries) {
            const el = entry.target;
            const newRect = el.getBoundingClientRect();

            if (
                activeTextarea === el &&
                (newRect.width !== initialSize.width ||
                    newRect.height !== initialSize.height)
            ) {
                if (!resized) {
                    resized = true;
                    el.fire("resize_start", { initialSize });
                }
            }
        }
    });

    surface.addEventListener("pointerdown", e => {
        const ta = e.target.closest("textarea");
        if (!ta || !surface.contains(ta)) return;

        activeTextarea = ta;
        resized = false;
        const rect = ta.getBoundingClientRect();
        initialSize = { width: rect.width, height: rect.height };
        observer.observe(ta);
    });

    const cleanup = () => {
        if (activeTextarea) {
            observer.unobserve(activeTextarea);
            if (resized) {
                const finalRect = activeTextarea.getBoundingClientRect();
                activeTextarea.fire("resize_end", {
                    initialSize,
                    finalSize: {
                        width: finalRect.width,
                        height: finalRect.height
                    }
                });
                if (typeof onResize === "function") {
                    onResize(activeTextarea, initialSize, finalRect);
                }
            }
            activeTextarea = null;
            initialSize = null;
            resized = false;
        }
    };

    surface.addEventListener("pointerup", cleanup);
    surface.addEventListener("pointercancel", cleanup);
}

trackUserTextareaResize(document);




Q.events = {
    textarea_auto_resize_height: function (elm, adrm, hnd, capt) {
        ["keyup"].map(function (ev) {
            // pt enter trebuie musai keyup ca sa faca resize
            elm[adrm](ev, Q.ev_hnd.textarea_auto_resize_height, capt || true);
        });
    },
    t2m: function (elm, adrm, capt) {
        ["touchstart", "touchmove", "touchend"].forEach(function (type) {
            elm[adrm](type, Q.ev_hnd.t2m, capt || false); // !!!BAC --- de verificat cu touch
            // elm[adrm](type, Q.ev_hnd.t2m, {passive: true}); // !!!BAC --- nu mai are prevent default si scroleaza si containerul
        });
    },
    scrollEnd: function (elm, adrm, hnd, capt) {
        console.log("###")
        if (!!hnd) {
            var A = (elm.scrollEndHnd = elm.scrollEndHnd || []);
            if (adrm === "AEL") {
                if (!A.has(hnd)) A.push(hnd);
            } else {
                A.remove(hnd);
            }
        } else {
            if (adrm === "REL") {
                elm.scrollEndHnd = [];
            }
        }
        elm[adrm]("scroll", Q.ev_hnd.scrollEnd, capt || false);
    },
};
Q.ev_hnd = {
    textarea_auto_resize_height: function (ev) {
        var tg = ev.target;
        // console.log(tg.computed('height'));
        if (tg.tagName === "TEXTAREA") {
            tg.auto_resize_height();
            tg.fire("textarea_resized");
        }
    },

    scrollEnd: function (ev) {
        var $ = this,
            to = $.scrollTop || document.body.scrollTop;
        !$.start_scroll_top && ($.start_scroll_top = to);
        clearTimeout($.timer);
        $.timer = setTimeout(throwScrollEndEvent, 150);
        function throwScrollEndEvent() {
            var sense = $.start_scroll_top - to;
            switch (true) {
                case sense > 0:
                    sense = "up";
                    break;
                case sense < 0:
                    sense = "down";
                    break;
                case sense === 0:
                    sense = null;
                    break;
            }
            var evObj = new window["CustomEvent"]("scrollEnd", {
                bubbles: true,
            });
            evObj.tail({ sense: sense, from: $.start_scroll_top, to: to });
            $.dispatchEvent(evObj);
            $.start_scroll_top = null;
            $.scrollEndHnd.map(function (hnd) {
                hnd(evObj);
            });
        }
    },
};

//Q.defined_touches = ["hold", 'tap', 'dbltap', 'swipeleft', 'swiperight', 'swipeup', 'swipedown'];
Q.combined_events = {
    swipe: ["swipeleft", "swiperight", "swipeup", "swipedown"],
    data_change: ["change_written", "undo", "redo", "modified"],
};

function on_off_event(type, hnd, capt, elm, adrm) {
    // accepta array of events sau string of events separate cu blank sau virgula
    if (gettype(type) === "Object") {
        // se poate si elm.on({click:click_hnd,keyup:click_hnd"})
        for (var t in type) {
            on_off_event(t, type[t], capt, elm, adrm);
        }
        return;
    }
    (typeof type === "string" ? type.match(/[^\s,]+/gim) : type).forEach(
        // fortez transformarea "type1 type2,type3" despartite de virgula sau spatiu in array
        // permit si elm.on([ev_type1, ev_type2 ...],hndler)
        function (ev_name) {
            ev_name = Q.combined_events[ev_name] || ev_name;
            typeof ev_name !== "string"
                ? on_off_event(ev_name, hnd, capt, elm, adrm) // am array de event_names si o iau de la capat
                : Q.events[ev_name]
                    ? Q.events[ev_name](elm, adrm, hnd, capt) // am tratare predefinita pt anumite eventuri --  adica ev_handler este impus
                    : elm[adrm](ev_name, hnd, capt); // situatia normala
        }
    );
}

NP.on = function (type, hnd, capt) {
    on_off_event(type, hnd, capt, this, "AEL");
    return this;
};
NP.off = function (type, hnd, capt) {
    on_off_event(type, hnd, capt, this, "REL");
    return this;
};
NP.once = function (type, hnd) {
    // if no flag
    var $ = this;
    (typeof type === "string" ? [type] : type).forEach((type) => {
        $.on(type, hnd, { once: true });
    });
    return $;
};

window.custom_named_events = {
    escape: { type: "keyup", data: { which: 27 } },
    scrollEnd: { type: "", data: {} },
};

window["fire"] = NP.fire = function (type, data = {}) {
    if (custom_named_events.hasOwnProperty(type)) {
        let ev = custom_named_events[type];
        this.fire(ev.type, ev.data.tail(data));
    } else {
        var type = { pik: "click", enter: "mouseover", leave: "mouseout" }[type] || type;
        var evObj = new CustomEvent(type, {
            bubbles: data.bubbles === false ? false : true,
        });
        evObj.tail(data);
        this.dispatchEvent(evObj);
    }
    return this;
};

function openPicker(inputDateElem) {
    var ev = document.createEvent("KeyboardEvent");
    ev.initKeyEvent("keydown", true, true, document.defaultView, "F4", 0);
    inputDateElem.focus();
    inputDateElem.dispatchEvent(ev);
    Q.i(ev);
}

window.on("keydown", (ev) => {
    if (ev.target.tagName === "TEXTAREA") {
        if (["int", "decimal", "float", "real"].has(ev.target.sql_type)) {
            if (ev.key === "Enter") {
                ev.preventDefault();
                //ev.target.fire("change");
                ev.target.blur();
                ev.target.focus();
            }
        }
    }
});

Object.defineProperties(Function.prototype, {
    as_name: {
        get: function () {
            var f = /function\s+(.*?)\(/.exec(this.toString());
            return f ? f[1] : "";
            // a se completa pt anonimous function stringify
        },
    },
    delay: {
        value: function (s) {
            // dn.delay(1.2)("abc")
            var $ = this;
            var CH = new Chain();
            return function (...A) {
                setTimeout(function () {
                    CH.resolve($.apply(this, A));
                }, parseFloat(s || 0));
                return CH;
            };
        },
        writable: true,
    },
    cb: {
        value: function (o, arg = {}) {
            var $ = this;
            return function (...A) {
                $.apply(this, A);
                o(...arg);
            };
        },
    },
    defer_: {
        get: function () {
            return this.delay(0);
        },
    },

    walk: {
        value: function (array) {
            var rez = [];
            for (var i in array) {
                array[i] = this(array[i]);
            }
            return array;
        },
    },
    //execute first of multiple fire and refuze repeating for a period of ms
    throtle: {
        value: function (time) {
            // miliseconds
            var $ = this;
            var f = function (...A) {
                // A0 = A;
                if (f.lock) return;
                setTimeout(function () {
                    f.lock = false;
                }, time);
                f.lock = true;
                return $.apply(this, A);
            };
            return f;
        },
    },
    throttle: {
        value: function (time) {
            const self = this;
            return function (...args) {
                if (this._throttleLock) return;
                this._throttleLock = true;
                setTimeout(() => {
                    this._throttleLock = false;
                }, time);
                return self.apply(this, args);
            };
        }
    },


});



Object.defineProperty(Function.prototype, 'debounce', {
    value: function (time = 300) {
        let timer;
        const originalFn = this;
        // console.trace("####")
        return function (...args) {
            const context = this;

            // Return a fresh promise per call
            return new Promise((resolve, reject) => {
                clearTimeout(timer);

                timer = setTimeout(async () => {
                    try {
                        //  console.log(__ML__)
                        const result = await originalFn.apply(context, args);
                        resolve(result);
                    } catch (err) {
                        reject(err);
                    }
                }, time);
            });
        };
    },
});





// pentru metode in obiect 
/**
 class C1{
    method1(){
    ...
        }
 } 
 C1.prototype.method1 = debounce( C1.prototype.method1,50)
 */

function debounce(func, delay) {
    let timer;
    return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => func.apply(this, args), delay);
    };
}


// disabled textarea resize height
// simulare dblclick cu poiterdown
var PP = {}
window.on("pointerdown", ev => {  // mousedown not working on disabled elements
    if (ev.target.tagName === "TEXTAREA" && ev.target.disabled) {
        if (PP.target === ev.target) {
            if (ev.timeStamp - PP.timeStamp < 300) {
                ev.target.auto_resize_height()
            }
        }
        PP = { target: ev.target, timeStamp: ev.timeStamp }
    }
});

window.on("click", ev => {
    if (ev.target.hasA("disabled")) {
        ev.stopPropagation();
        ev.stopImmediatePropagation()
    }
}, { capture: true });




Object.defineProperties(HTMLUListElement.prototype, {
    // necesar pentru [tabs]  si x-tabs
    active_panel: {
        get: function () {
            return this.panels[this.selected_tab];
        },
    },
    active_button: {
        get: function () {
            return this.buttons[this.selected_tab];
        },
    },
    buttons: {
        get: function () {
            return this.find(":scope >li >a");
        },
    },
    panels: {
        get: function () {
            if (!this.next) {
                console.log("tabs require a  <div tabs> ul[buttons] div[panels] </div>  structure")
                return 0;
            }
            return this.next.find(":scope > div");
        },
    },
});

Object.defineProperty(EP, "_scope_", {
    get: function () {
        let panel = this.closest("[tabs_panel]");
        return panel ? panel.xtab.selected_scope : null;
    }
})


/*
 *
 *  ideea de baza e sa cauti intr-un context (dom tree) toate elementele care au un anumit atribut si pt fiecare dintre ele sa se execute o funtie js care sa modifice pagina
 *  probabil ca pe viitor o sa trec la custom element ca alternativa mai incapsulabila
 *
 */
Q.init = function (obj, context) {
    // aha == Advenced HTML Attributes
    context = context || document.body;
    obj = obj || Q.init.defaults;
    for (var atr in obj) {
        //daca elementul insusi are un atribut care presupune initializare si nu a fost inca initializat
        context.hasA(atr) && !Q.init.test(context, atr) && obj[atr].bind(context)(context);
        // pt descendents
        Q("[" + atr + "]", context).map(function (elm) {
            !Q.init.test(elm, atr) && obj[atr].bind(context)(elm); // this is binded to element that run init();
        });
    }
};
EP.init = function (obj) {
    //console.trace(this, obj)
    Q.init(obj, this);
    return this;
};

/*Q.init(
 {jsc:'',edit:edit_handler}, MAIN
 )
 // cauta in elementul MAIN tagurile cu attribut jsc si executa default handler +  cauta  attr edit si executa handlerul dat 
 */
Q.init.defaults = {
    jsc: function (elm) { // javascript console (like)
        var w = elm.wrap();
        elm.setA({ contenteditable: "true", spellcheck: "false" });
        var run = _E("<div run>").css("vertical-align:top");
        function handle() {
            try {
                // evaluate js
                var clean_code = elm.innerHTML
                    .replace(/<label>.*?<\/label>/, "")
                    .replace(/<(flag|cmt).*?>(.|\n)*?<\/\1>/gim, "")
                    .replace(/<.*?>/gim, "")
                    .replace(/&gt;/gim, ">")
                    .replace(/&lt;/gim, "<");
                var rez = eval(clean_code);
                if (elm.hasA("jsc", "once")) {
                    // put radic for once done
                    run.off("click", handle);
                    _E("span", " &radic;").css("color:green !important;font-size:1.5em;font-weight:bold").oust(run);
                    elm.remA("contenteditable");
                }
                if (elm.hasA("jsc", "echo")) elm.parent.lastChild.html = rez;
                elm.fade(0.4, 0.2, nf, "sin");
            } catch (err) {
                // show error notice
                elm.notice(err);
                elm.focus();
            }
        }
        run.on("click", handle);
        w._(run);
        w._(_E("shell_print").css("_display:block;margin-left:1em"));
        if (/^auto/.test(elm.getA("jsc"))) {
            run.fire("click");
        }
    },

    see_file: function (elm) {
        if (!elm.getAttribute("href")) {
            elm.html = "??? href ???";
            return;
        }
        if (!elm.html.trim()) {
            elm.html = " <idiom>" + (elm.getAttribute("href") || "").basename + "</idiom> ";
        }

        elm.on("click", function (e) {
            elm.tmpA("frozen");
            e.preventDefault();



            var src = this.getAttribute("href"),
                ext = src.nve.e;
            for (let vv of allViews) {
                if (vv.bla === src) {
                    vv.link.fire("hold");
                    vv.frame.scale(1.3, .5, nf, sin);
                    return
                }
            }

            var v = new View();
            if (ext === ".pdf") {
                let e = _E("embed").setA({ src }).css("width:100%;height:100%");
                v.content._(e);
                v.content.css("overflow:hidden;padding:0;");
            }
            else {
                v.src = src;
            }

            v.jumpTop();
            v.bla = src;
            v.cucu = 1
            v.title = src.replace(location.origin + "/", "");
            v.content.css("white-space:pre;" + (elm.getA("content_style") || ""));

        });
    },
    _cal: function (elm) {
        //CALENDARES
        console.log(elm.id || elm);
    },

    accordion: function (elm) {
        /*
         * EX:
         *    <div accordion opis='accordion'>
         *     .... repeat structure bellow ...
         *       <div>
         *          <div>title of panel </div>
         *          <div>
         *              <div>content of panel</div>
         *          </div>
         *     </div>
         *     ..............
         *    </div>
         */
        var opened_idx = elm.getA("opened_idx");
        [...elm.children].map(function (tab, idx) {
            // prevent touchend bubling from childNodes to start click on tab
            tab.on("touchend", function (ev) {
                ev.preventDefault();
            });
            +opened_idx !== idx && tab.setA("collapsed");
            tab.first.setA("accordion_title");
            tab.first.on("click", function (ev) {
                tab.togA("collapsed");
                elm.setA("opened_idx", "" + [...tab.parent.children].indexOf(tab));
                tab.siblings().map(function (i) {
                    i.setA("collapsed");
                });
            });
        });
        setTimeout(() => elm.setA("animated"), 0);
    },

    tabs: function (elm) {
        /*
         * EX: 
         <div tabs memorize='ciaka_paka_memory_id'>
            <div>any content here ignored chiar si un  <ul> nu este descendent direct </ul></div>
            <ul>
                <li class='active' opis>
                    <a>btn1</a>   
                </li> // opis attribute only in li dot in a
                <li opis>   <a>btn2</a>    </li>
            </ul>
            <div pannels_container>  // ul.next !!!BAC>>> nu baga nimic intre 
                <div>pnl1_content</div>
                <div>pnl2_content</div>
            </div>
         </div>
         * a se vedea myadr/alocare_solicitare 
         */

        // depinde de boostrap.css si de pik pt ipad .. merge cu tap
        var ul = elm.find(":scope >ul")[0];
        if (!ul) {
            console.log("[tabs] >>> ERROR `ul` missing!");
            return;
        }

        elm.ul = ul;

        let B = ul.buttons,
            P = ul.panels;
        if (P.length !== B.length) {
            console.log("[tabs] >>> probleme de structura in ", elm, B, P);
            return;
        }
        ul.setC("nav nav-tabs");
        ul.next.setA("panels_container");
        var active_idx = 0;

        B.map(function (a, idx) {
            a.parent.hasC("active") && (active_idx = idx);
            P[idx].btn = a;
            P[idx].setA("tabs_panel");
            a.parent.tab = idx + "";
        });




        ul.on("click", function (ev) {
            var tg = ev.target.closest("a");
            if (tg && !tg.hasA("disabled") && !ul.hasA("disabled")) {
                //tg.tmpA("disabled", 200);
                if (ev.isTrusted && ul.switch_trap) {
                    // capturez click real (trusted) -- conditionez switching-ul de ceva --  ex session.drop_changes();
                    // functia va trebui sa faca ev.target.click(); care va avvea not trusted event deci nu mai trece pe aici 
                    ul.switch_trap(ev);
                    return;
                }
                var nth = ul.buttons.indexOf(tg);
                if (ul.selected_tab !== nth) {
                    // nu pot selecta selectatul !!!
                    if (ev.isTrusted && (ul.edit_protect || ul.protect_editing) && session.changes) {
                        if (confirm("DROP CHANGES AND SWITCH TAB?")) {
                            session.drop_changes();
                            setTimeout(() => {
                                ev.target.click();
                            }, 300);
                        }
                        return;
                    }
                    ul.prev_selected_tab = ul.selected_tab;
                    ul.select(nth, ev);
                }
            }
        });
        ul.select = function (nth, ev = {}) {
            // ev or object passed
            ul.selected_tab = nth;
            ul.buttons.map(function (a, idx) {
                nth === idx
                    ? a.parent.setC("active") // a.parent === li
                    : a.parent.remC("active"); // li
            });
            ul.panels.map(function (pn, idx) {
                if (nth === idx) {
                    pn.setA("active");
                    setTimeout(function () {
                        //  pn.fade(1);
                        pn.style.opacity = 1;
                        var event_data = {
                            nth: nth,
                            old_nth: ul.prev_selected_tab,
                            buttons: ul.buttons,
                            trusted_parent_event: ev.isTrusted,
                            parent_event: ev,
                            bubbles: true,
                        };
                        ul.fire("switch", event_data); // important pt OPISIZER
                        pn.find(":scope >[tpl_wrapper]").map((e) => e.fire("tab_selected", event_data)); // pot avea in template-ul citit in panel _i.on("tab_selected",fn)
                        if (ev.reveal) { // selectare recursive upword
                            // tabs under tabs --- reveal tree up
                            let parent_tabs_panel = ul.parent.closest("[tabs_panel]");
                            if (parent_tabs_panel) {
                                let parent_ul = parent_tabs_panel.parent.prev;
                                setTimeout(() => {
                                    parent_ul.select(parent_ul.panels.indexOf(parent_tabs_panel), { reveal: true });
                                }, 0);
                            }
                        }
                    }, 0);
                } else {
                    pn.remA("active");
                    pn.style.opacity = 0;
                    pn.fire("tab_deselected");
                }
            });
            if (ul.memorize) {
                var LSM = (localStorage.memorized_tabs || "{}").parsed;
                LSM[ul.memorize] = nth;
                localStorage.memorized_tabs = JSON.stringify(LSM);
            }
        };

        var M = elm.getA("memorize");

        if (M) {
            var nth = (localStorage.memorized_tabs || "{}").parsed[M];
            ul.memorize = M;
            ul.select(+nth || active_idx);
        } else {
            ul.select(active_idx);
        }
    },

    shup: function (elm) {
        elm.shupify();
        if (elm.hasA("shup", "auto"))
            setTimeout(function () {
                elm.fire("mousedown");
            }, 100);
    },

    get_info: function (elm) {
        // populez cu informatie pt shup
        Q.ajax({
            src: elm.getA("get_info"),
            cb: function (rsp) {
                var all = elm.querySelectorAll("[info]");
                //dn("GET_INFO<br/>" + rsp);
            },
            type: "xml",
        });
    },
    get: function (elm) {
        // ex: <div get="src:/ret.php"></div>
        elm.get(elm.getA("get").s2o);
    },

    _v_: function (elm) {
        // !!! ATENTIE --- elm.init() binds this to element la get si template
        try {
            var value = eval(elm.getA("_v_"));
            elm.tagName === "INPUT" ? (elm.value = value) : (elm.html = value);
        } catch (err) {
            console.log(err);
        }
    },

    onoff: function (elm) {
        /*
         * EX:
         * <div  onoff collapsed>TITLU PANEL COLAPSABIL</div>  // collapsed on start or remove attribute
         * <div style='height:150px;'>
         *     ... collapseble content
         *  </div>
         */

        var options = elm.getA("onoff").s2o,
            tg = !options.target ? elm.next : Q("#" + options.target, this);
        if (!tg.innerText.trim()) {
            elm.setA("hidden");
        }
        tg.setA("onoffed", "init").setA("hint_panel").btn = elm;
        elm.setA("collapsed");

        elm.on("click", function () {
            if (elm.togA("collapsed")) {
                // se inchide
                setTimeout(function () {
                    tg.setA("collapsed").style.height = 0;
                }, 0);
            } else {
                // tg.style.height = tg.height_when_opened || 'auto';
                var clone = tg.cloneNode(true).css("").css({ display: "hidden", zIndex: -1 }).remA("collapsed");
                tg.parent._top(clone);
                tg.style.height = clone.h + "px";

                clone.die();
                tg.remA("collapsed");
                tg.fire("opened");
            }
        });
        if (elm.hasA("collapsed")) {
            // memorez inaltimea dorita la deschidere
            tg.setA("collapsed");
            tg.style.height = 0;
        }
        tg.on("opened", (ev) => {
            if (ev.target !== tg && tg.hasA("collapsed")) {
                // s-a deschis ceva din interior si e normal sa se deschida si asta cascadat
                tg.style.height = tg.height_when_opened;
                tg.remA("collapsed");
            }
        });
        setTimeout(() => tg.setA("_anm_").css("overflow:auto"), 0);
    },
    couple_onoffs: function (elm) {
        var onoffs = [...elm.find("[onoff]")];
        elm.on("opened", function (ev) {
            var tg = ev.target,
                other = onoffs.remove(tg);
            other.map(function (el) {
                if (!el.hasA("collapsed")) el.click();
            });
        });
    },
    fixify: function (elm) {
        elm.fixified = 1;
    },
    markdown: async function (elm) { // _::md2html($text/file_path, is_file);
        _i.find("[class*=language]").map((e) => {
            e.oust(e.parent)
            let lang = e.getA("class").split("-")[1];
            e.setA("label");
            Q.hl(e, { lang, });
        });
    }

};

// !!! evit initializare multipla

Q.init.test = function (elm, attr) {
    let X = elm.getA("init");
    if (X && new RegExp(attr, "gim").test(X)) {
        // prevent double initialization; //  imi scapa motivul pt care se intampla
        return 1;
    } else {
        elm.setA("init", X ? X + "," + attr : attr);
        return 0;
    }
};

let lang_abreviations = { js: "javascript", py: "python" };
Q.init.defaults.hl = (elm) => {
    //    console.log(elm);
    let O = elm.getA("hl").s2o,
        c = _E("code", elm.html);
    elm._clr(c);
    elm.setC("language-" + O.lang);
    import("/aha/js/prismjs/prism.js")
        .then((M) => {
            return import("/aha/js/prismjs/components/prism-" + (lang_abreviations[O.lang] || O.lang) + ".js");
        })
        .then(() => {
            Prism.highlightElement(elm);
            O.hasOwnProperty("count") && Prism.countLines(elm, O.count);
            if (elm.hasA("label")) {
                let lbl_cmt = elm.getA("label").trim(),
                    label_txt = "<m style='color:yellow'>" + O.lang + "</m>" + (lbl_cmt ? ": <i>" + lbl_cmt + "</i>" : ""),
                    l = _E("label", label_txt);
                elm._top(l);
            }
            Prism.override(elm);
        });
};
Q.hl = (elm, opt = { lang: "txt", count: false }) => {
    // daca elementul nu e pre atunci il inlocuiesc cu copierea attributelor
    let pre = _E("pre", elm.html);
    pre.copyA(elm);
    pre.setA({ hl: opt.o2s() });
    pre.init({ hl: Q.init.defaults.hl });
    pre.oust(elm);
};






// OPISIZE

// RULE - INDEXING   opis="NAME_TO_SHOW|opis_parent_label|self_label"   3 segments  -- OPIS_PATH using pipe --- none of segments can use pipe
// EX:  <div opis="div1|0|AAA"> ... </div> .... <div opis="div2|AAA|"   -- 0 means no parent;top   -- the 3rd segment is optional
// onion style default --- force find my first opisized parent
// <div opis='d1'> ... <div opis='d2'></div></div>  --- d2 is under d1
// segment2='^' or segment2='' adica    xxx||yyy or xxx|^|yyy
window.OPISIZER = { last_selected: 0 };
(function () {
    var K,
        prevent_opisize_loop,
        Y0_OFFSET = 50,
        Y_CORECTION,
        interface,
        mem_btn = _E("", " MEM").setA({
            letter_btn: 1,
            led: 1,
            style: "font-size:.8em;margin-left:2em",
        }),
        top_banner = _E("<div style='background:rgb(0 0 0 / 32%);line-height:.5em;cursor:pointer;color:white;z-index:1;font:1.4em Arial;padding:.3em ;letter-spacing: 1px;margin-bottom:1em'></div>"),
        WRAP = _E("<div opis_wrapper></div>"),
        go_top = _E("", "OPIS").setA("letter_btn");

    go_top.on("click", () => (document.documentElement.scrollTop = 0));
    mem_btn.on("click", function (ev) {
        //set_memorize_mode
        ev.stopPropagation();
        LS.pointer("memorized_scroll." + interface, ev.target.togA("on") ? document.scrollingElement.scrollTop : false);
    });

    top_banner._(go_top);

    Q.init.defaults.opisize = function (elm, update_only) {
        // numai ce e sub #MAIN adica edit_surface  poate fi opisat --- FF IMPORTANT --- nu are sens altceva
        if (!update_only) {
            if (elm.closest_parent("[opisize]")) {
                // am un alt element mai sus care impune opisarea (php include poate induce situatia asta)
                elm.remA("opisize");
                return;
            }
            if (elm.parent !== MAIN) {
                if (elm.parent.parent === MAIN) {
                    elm.parent.setA("opisize", elm.getA("opisize"));
                    Q.init.defaults.opisize(elm.parent);
                    elm.remA("opisize");
                } else {
                    // console.log("OPISIZE ERROR ");
                }
                return;
            }

            OPISIZER.elm = elm;

            Y_CORECTION = parseInt(MAIN.computed("margin-top"));
            OPISIZER.opt = {}.tail((elm.getA("opisize") || "").s2o); // optinuni in tag

            elm.reflect(
                {
                    childList: true,
                    subtree: true,
                },
                update_opis_on_dom_mutation
            ); // refacerea opisului daca apar sau dispar element cu attribute opis indiferent de nivel
            elm.parent._(WRAP);

            // recover_memorized_scroll();
            elm.on("switch", reflect_tabs_switch_in_opis);
        }
        var ul = build_ul_structure(elm, OPISIZER.opt).setA("opis_top").setA("default_bg");
        ul.on({ click: scroll_document_to_anchor });
        ul._top(top_banner);
        //        OPISIZER.opt.mem && mem_btn.remA("hidden") ||  mem_btn.setA("hidden");
        WRAP._clr(ul);
        OPISIZER.ul = ul;
    };

    function scroll_document_to_anchor(ev) {
        var tg = ev.target,
            simulate_scroll = false;
        if (tg.opis) {
            tg.opis.fire("expand_dom_above");
            //console.log(tg, tg.opis);
            var y = tg.opis.offsetTop - Y_CORECTION;

            // selectarea tabului corespunzator din click pe opis
            var tabs_panel = tg.opis.closest("[tabs]");
            if (tabs_panel) {
                tg.opis.first.click(); // click pe <a> sin tabul de selectat
                simulate_scroll = true;
            }

            // desfasurarea onoff daca e cazul
            var onoffed = tg.opis.closest("[onoffed]");
            if (onoffed) {
                if (onoffed.hasA("collapsed")) {
                    onoffed.btn.click();
                }
            }



            // daca am animatii cascadate ex onoff in onoff  tre sa astept pagina sa se dimensioneze
            var scroll_top = y - Y0_OFFSET;

            // OPISIZER.opt.smooth ? document.scrollingElement.scrollY(scroll_top) : (document.scrollingElement.scrollTop = scroll_top);
            if (Q.bool(OPISIZER.opt.smooth)) {
                document.documentElement.tmpA("smooth-scroll");
            }
            document.scrollingElement.scrollTop = scroll_top;

            if (simulate_scroll) {
                setTimeout(function () {
                    document.fire("scroll", {});
                }, 10);
            }
        }
    }

    function is_non_opisable(elm) {
        // numai ce e sub #MAIN  poate fi opisat --- FF IMPORTANT --- nu are sens altceva
        return 0;
        if (!elm) {
            return 1;
        }
        if (elm.parent !== edit_surface) {
            elm.remA("opisize");
            return 1;
        }
        return 0;
    }

    function build_ul_structure(elm, opt) {
        var ul = _E("<ul opis_list></ul>"),
            o = {},
            A = [];
        K = 0;
        // generare elemente
        (OPISIZER.anchors = elm.find("[opis]")).map(function (e) {
            var D = repair_opis_attribute(e);
            var li = _E("<li opis_lbl=~|" + D[1] + "|" + D[2] + ">" + (D[0] + "") + "<ul opis_list></ul></li>"); // orice li contine un ul pt arborele descendent --- eventual gol
            var desc_lbl = D[2]; // self__labeling_for descendents
            if (o[desc_lbl]) {
                console.log("*** SAME desc_lbl='" + desc_lbl + "' CONFLICT ***", e, o[desc_lbl].opis); //am 2 elemente cu acelasi label descendent iese o harababura;
            }
            o[desc_lbl] = li;
            A.push(desc_lbl);
            li.parent_lbl = D[1];
            (e.opis = li), (li.opis = e); // elementul opisat si li-ul de opisare se referentiaza  reciproc cu proprietatea opis   elm.opis.opis === elm
        });
        // agregare
        for (var i in A) {
            var v = A[i];
            var li = o[v];
            try {
                if (+li.parent_lbl === 0) {
                    ul._(li);
                } else {
                    o[li.parent_lbl].first._(li);
                }
            } catch (err) {
                //console.log("PROBLEME OPIS : " + err.message + ' : ', o[v].opis, o[v]);
            }
        }
        OPISIZER.labels = o;
        return ul;
    }

    function repair_opis_attribute(e) {
        // logica de selectie in DOM nu ma obliga la recursivitate !   --hope--
        if (!e.opis0) {
            e.opis0 = e.getA("opis").split("|").trim(); // memorez attributl original in caz de rebuild
        }
        var atr = e.opis0,
            d = [atr[0] || "-?!-", atr[1], atr[2] || "_fix" + K++];
        if (atr.length < 3 || d[1] === "^" || !d[1]) {
            if (!d[1] || d[1] === "^") {
                var po = e.closest_parent("[opis]");
                d[1] = po ? po.getA("opis").split("|")[2] : 0;
            }
            e.setA({ opis: d.join("|") });
        }
        // nu ar trebui sa verific ca exista parintele indicat ??? ...|parent_label|... ---  daca e scris gresit?
        return d;
    }

    function update_opis_on_dom_mutation(...arg) {
        // tre sa updatez si opise_anchors array
        var UPDATE = false;
        arg[0].map((mutation) => {
            var ADD = !!mutation.addedNodes.length,
                ELM = ADD ? mutation.addedNodes[0] : mutation.removedNodes[0];
            if (ELM instanceof HTMLElement) {
                var opisized_childs = ELM.find("[opis]");
                if (ELM.hasA("opis") || opisized_childs.length) {
                    // e cazul sa updatez opisul
                    UPDATE = true;
                }
            } else {
                //console.log(...arg,ELM);
            }
        });
        if (UPDATE) {
            Q.init.defaults.opisize(OPISIZER.elm, true);
            requestAnimationFrame(function () {
                react_on_scroll();
            });
        }
    }

    function decorate_sub_tree(tg, ev) {
        tg.setA("selected");
        tg.siblings().as1("remA")("selected");
        tg.find("ul >li").map((li) => li.remA("selected"));
        OPISIZER.last_selected = tg;
    }

    function decorate_tree_above(li, ev) {
        while (li && li !== OPISIZER.ul) {
            if (!li) break;
            li.setA("selected");
            li.siblings().map(function (op) {
                op.remA("selected");
            });
            li = li.parent.parent;
        }
    }

    function react_on_scroll(ev) {
        if (OPISIZER.elm) {
            requestAnimationFrame(function () {
                var scroll_top = document.scrollingElement.scrollTop;
                var cli = decide_current_opis_li(scroll_top, ev);
                if (cli) {
                    OPISIZER.last_selected !== cli && decorate_sub_tree(cli, ev);
                    cli.parent.parent && !cli.parent.parent.hasA("selected") && decorate_tree_above(cli, ev); // daca  li-ul parinte nu este selectat  am un tree inchis
                }
            });
        }
    }

    function decide_current_opis_li(scroll_top, ev) {
        var cli,
            A = OPISIZER.anchors,
            pos = A.map(function (sc) {
                return Math.abs(sc.offsetTop - scroll_top - Y0_OFFSET);
            });

        var min = null,
            minx = [];
        pos.map((y, i) => {
            if (min === null || y < min) {
                min = y;
                minx = [i];
            } else if (y === min) {
                minx.push(i);
            }
        });

        if (minx.length === 1) {
            cli = A[minx[0]].opis;
        } else {
            // am dat de o zona TABULARIZATA  ---  mai multe elemente la acelas nivel si deduc cea activa/vizibila
            minx.map((idx) => {
                if (A[idx].hasC("active")) {
                    //   <div tabs><ul>  <li opis='a|b|c' class='active'><a></a></li>....</ul>
                    cli = A[idx].opis;
                }
            });
            if (!cli) {
                var li = A[minx[0]];
                if (li) {
                    li.setA("active");
                    cli = li.opis;
                }
            }
        }
        return cli;
    }

    function reflect_tabs_switch_in_opis(ev) {
        var ul = ev.target;
        if (ul.parent.hasA("tabs") && ev.trusted_parent_event) {
            ul.buttons.map((a) => a.parent.opis === OPISIZER.last_selected && document.fire("scroll"));
        }
    }

    //    var lazy_memorize_interface_scroll = (function (scroll_top) {
    //
    //        if (mem_btn.hasA("on")) {
    //            LS.pointer("memorized_scroll." + interface, scroll_top);
    //        }
    //    }).debounce(100);

    document.on("scroll", react_on_scroll);

    // SCROLEND -- EVENT
    var timer,
        a = [0, 0];
    document.on("scroll", function (ev) {
        a[0] = a[1];
        clearTimeout(timer);
        a[1] = document.scrollingElement.scrollTop;
        timer = setTimeout(function () {
            document.fire("scrollend", {
                sense: a[0] > a[1] ? "up" : "down",
                oev: ev,
            });
        }, 150);
    });
})();

function getScrollbarWidth() {
    // Creating invisible container
    const outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.overflow = "scroll"; // forcing scrollbar to appear
    outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
    document.body.appendChild(outer);

    // Creating inner element and placing it in the container
    const inner = document.createElement("div");
    outer.appendChild(inner);

    // Calculating difference between container's full width and the child width
    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);

    return scrollbarWidth;
}
function setScrollbarWidth() {
    window.scrollBarWidth = getScrollbarWidth();
    document.head._(
        _E(
            "style",
            `[blinded] #all_menu_buttons .gradient{
            padding-right: ${scrollBarWidth}px;
            }
        [blinded] #b_bar{
            padding-right: ${scrollBarWidth}px;
        }
        body[blinded]{
            overflow: hidden;
            margin-right: ${scrollBarWidth}px;
        }`
        ).setA("calculated-scroll-bar-width")
    );
}













// CONTEXTMENU

Q.contextmenu_conf_exaple = {
    see_event: {
        do: (ev) => { Q.i(ev); console.log(ev.target) }
    },
    item_1_: {
        icon: "svg:flower_smile",
        do: () => () => {
            setTimeout(() => {
                console.log("CACAT");
            }, 1000);
        },
        sep: 2, // ADD SEPARATOR
        attr: { A: 1, B: 2 },
        hint: "<div vsp1><cmt>ABC<br/>this is a hint</cmt></div>",
        menu: {
            // SUBMENU
            item1_1: {
                do: (ev) => Q.i(ev),
            },
            item1_2: {
                do: () => dn("item1_2"), // nu o sa mearga pt ca are subordonati 
                menu: {
                    sub_itgem: { icon: "add", do: () => { Q.i(this) } }
                },
                sep: 1,
            },
            item1_3: {
                disabled: 1, // DISABLE
            },
        },
    },
    item2: {
        icon: "svg:help",
        do: function (ev) {
            console.log(ev, this);
        },
    },
};


// global contextmenu
window.context_menu = function (target, conf_obj, condition) {
    context_menu.target = target;
    context_menu.conf(conf_obj, condition);
    return context_menu;
};


Object.defineProperties(context_menu, {
    conf: {
        value: function (OBJ, condition) {
            console.log(OBJ);
            let M;
            if (condition && condition()) { // logica cu return 0 or false  ca la bash 
                M = _E(); // empty menu -- fake context
            } else {
                M = this.gnr_level(OBJ);
                M.setA("_anm_");
            }
            M.oust(this.panel);
            this.panel = M;
            return this;
        }
    },
    show: { // pozitioneaza contextmenu.panel 
        value: function (x, y) {
            //console.trace(x, y);
            let M = this.panel;
            requestAnimationFrame(function () {
                let _wh_ = window.scrollY + window.innerHeight,
                    _ww_ = window.scrollX + window.innerWidth,
                    _mh_ = M.offsetHeight,
                    _mw_ = M.offsetWidth,
                    _offset_ = 150;
                if (x + _mw_ < _ww_) {
                    // place to right of pointer
                    M.style.left = x + "px";
                    if (x + _mw_ + _offset_ > _ww_) {
                        M.setA("expand_left");
                    }
                } else {
                    M.style.left = x - _mw_ + "px";
                    if (x + _offset_ > _ww_) {
                        M.setA("expand_left");
                    }
                }
                M.style.top = (y + _mh_ < _wh_ ? y : y - _mh_) + "px";
                M.classList.add("show-menu");
            });
            return this;
        },
    },
    hide: {
        value: function () {
            this.panel.classList.remove("show-menu");
            this.panel.fire("contextmenu_off");
        },
    },
    gnr_level: {
        value: function (OBJ = Q.contextmenu_conf_exaple, level = 0) {
            var $ = this;
            let M = _E("menu").setC("menu");
            M.on("click", (ev) => ev.stopPropagation);
            for (let item in OBJ) {
                let D = OBJ[item],
                    A = (D.icon || "svg:empty").split(":"), // lipsa e svg empty
                    icon = A[0] === 'svg' ?
                        '<img height="16" src="aha/svg/' + A[1] + ".svg" + '" />' :
                        (/<icon/.test(D.icon) ? D.icon : "<icon>" + D.icon + "</icon>")

                let LI = _E(
                    '<li class="menu-item"><button  class="menu-btn"> ' +
                    icon +
                    '<span class="menu-text">' +
                    item +
                    (D.hint || "") +
                    "</span>" +
                    "</button></li>"
                );
                LI.setA({
                    level: level + "",
                    id: "menu_" + item,
                    ...(D.attr || {}),
                });
                D.disabled && LI.setC("disabled"); // clasa .disabled are pointer-events:none
                D.hidden && LI.setA("hidden");
                LI.on("click", (ev) => {
                    ev.stopPropagation();
                    if (!D.menu) {
                        context_menu.hide();
                        (D.do || nf)(ev);
                        // !!!BAC>>> in functia  do o sa am this ca si contex_menu function/object
                        // !!!BAC>>> eventul luat in calcul nu e click-ul pe panel-ul de context ci right_clicul dat anterior pe DOM
                    }
                });
                if (D.menu) {
                    LI._(this.gnr_level(OBJ[item].menu, level + 1));
                    LI.setC("submenu");
                }
                M._(LI);
                if (D.sep) {
                    for (let i = 0; i < D.sep; i++) {
                        M._('<li class="menu-separator"></li>');
                    }
                }
            }
            return M;
        },
    },
});

context_menu.panel = _E("menu").setC("menu"); // placeholder 
document.documentElement._(context_menu.panel);
document.addEventListener("click",
    //"pointerdown", !!!BAC>>> NU e bun 
    function hide_context_menu() {
        context_menu.hide();
    },
    true
);
document.addEventListener("keyup", function (ev) {
    ev.key === "Escape" && context_menu.hide();
});

0 && document.addEventListener(
    "contextmenu",
    function (ev) {
        context_menu.hide();
    },
    true
);

document.addEventListener(
    "wheel",
    function (ev) {
        context_menu.hide();
    },
    true
);


EP.context_menu = function (OBJ, condition) {
    let $ = this;
    if ($.contextmenu_handler) { // remove previous contextmenu listener
        this.removeEventListener("contextmenu", $.contextmenu_handler, true);
    }
    if (OBJ) {
        let F = function (ev) {
            if (ev.altKey) { // !!!BAC>>>   ca sa pot accesa developer-tools
                return;
            }
            ev.stopImmediatePropagation();
            var MENU_DESCRIPTOR = OBJ;
            if (OBJ instanceof Function) {
                MENU_DESCRIPTOR = OBJ.bind($)(ev, condition);
            }
            ev.preventDefault();
            if (Object.keys(MENU_DESCRIPTOR || {}).length) { // verific  ca are sens sa supracriu contextmenu
                context_menu.event = ev;
                context_menu.pointedElement = ev.target;
                var x, y;
                if (!ev.pageX) {
                    if (ev.hasOwnProperty('x')) {
                        x = ev.x;
                        y = ev.y;
                    }
                    else {
                        let OOO = ev.target.geometry;
                        x = OOO.x + OOO.w / 2
                        y = OOO.y + OOO.h / 2
                    }
                }
                else {
                    x = ev.pageX;
                    y = ev.pageY;
                }
                context_menu($, MENU_DESCRIPTOR, condition).show(x, y);
            }
        };
        this.addEventListener("contextmenu", F, true);
        $.contextmenu_handler = F;
    }
};









// ******* DELEGATED EVENTS *************

// opresc linkuri default AJAX NAVIGATION
//document.on("tap click", function (ev) {
//    var tg = ev.target;
//    if ( tg.nodeName === "A") {
//        ev.preventDefault();
//        // ev.stopPropagation(); // nu trebuie ca opreste touch
//    }
//}, true);




Q.manifest = {};

// !!! PT  AJAX NAVIGATION



Q.eval = function (obj) {
    return Function('"use strict";return (' + obj + ")")();
};
Q.regexp = {
    tags: /<[^>]*>/gim,
    url: /^(?:(.*?):\/\/?)?\/?(?:[^\/\.]+\.)*?([^\/\.]+)\.?([^\/]*)(?:([^?]*)?(?:\?([^#]*))?)?(.*)?/,
    err: /^(?:(.*?):\/\/?)?\/?(?:[^\/\.]+\.)*?([^\/\.]+)\.?([^\/]*)(?:([^?]*)?(?:\?([^#]*))?)?.*?:(\d*):(\d*)\)/,
    safe_pass: /(?=.*[a-z])(?=.*\d)(?=.*[A-Z])(?=.*[~!@#$%^&*\(\)+{}\[\]\?]).{10,20}/, // impune >= o litera mica >= o liteara mare >= o cifra + caracter special + min_length 10
};
Q.bool = function (sob) {
    if (typeof sob === "string") {
        return ["no", "false", "0", "off", "undefined", "", "null"].indexOf(sob.toLowerCase()) !== -1 ? false : true;
    } else {
        return !!sob;
    }
};

Object.defineProperty(Error.prototype, "human", {
    get: function (str) {
        var sg = this.stack.split("\n")[2];
        console.log(this.stack);
        var rez = Q.regexp.err.exec(str);
        return "'" + this.message + "' \t " + (rez ? rez[4] + ":" + rez[6] : "");
    },
});



Object.defineProperties(Math, {
    scientific_to_num: {
        value: function (num) {
            //if the number is in scientific notation remove it
            if (/e/i.test(num)) {
                var zero = "0",
                    parts = String(num).toLowerCase().split("e"), //split into coeff and exponent
                    e = parts.pop(), //store the exponential part
                    l = Math.abs(e) || 0, //get the number of zeros
                    sign = e / l,
                    coeff_array = parts[0].split(".");
                if (sign === -1) {
                    //num = zero + "." + new Array(l).join(zero) + coeff_array.join("");
                    num = zero + "." + "0".repeat(l) + coeff_array.join("");
                } else {
                    var dec = coeff_array[1];
                    if (dec) l = l - dec.length;
                    num = coeff_array.join("") + new Array(l + 1).join(zero);
                }
            }
            return num;
        },
    },
    precision: {
        value: function (value, precision, type) {
            var v = parseFloat(value),
                p = Math.max(precision, 0) || 0,
                t = type || "round";
            return Number((Math[t](v * 10 ** p) / 10 ** p).toFixed(p))
            return (Math[t](v * Math.pow(10, p)) / Math.pow(10, p)).toFixed(p);

        },
    },
    get_precision: {
        value: function (number) {
            var arr = Math.scientific_to_num(number + "").split(".");
            return Math.min(arr[1] ? arr[1].length : 0, 10); // sa nu-mi apara -1e-11  ca -0 
        },
    },
    max_precision: {
        value: function (...A) {
            var max = 0;
            for (var i = 0; i < A.length; i++) {
                max = Math.max(max, this.get_precision(A[i]));
            }
            return max;
        },
    },
    diff: {
        value: function (A, B) {
            var prec = this.max(this.get_precision(A), this.get_precision(B));
            return +this.precision((parseFloat(A) || 0) - (parseFloat(B) || 0), prec);
        }, writable: true,
    },
    sum: {
        value: function (...A) {
            var prec = 0,
                sum = 0;
            for (var i = 0; i < A.length; i++) {
                prec = this.max(prec, this.get_precision(A[i]));
                sum += parseFloat(A[i]) || 0;
            }
            return +this.precision(sum, prec);
        },
    },
    acm: { // accumulate  --  de valori din obiecte sau collectii  -
        // ex1:  ACM={X:0,A:4 } , SRC = {A:1.1,B:3} ; Math.acm( ACM, SRC, "*" ) --> {X:0, A:5.1, B:3}
        // ex2:  ACM ={}, SRC =[ { A:1, B:[0,{C:3}, D:{E:.1,F:.2}] }, {A:2, B:[11,{C:1}, D:{F:33}] } ]   
        //       Math.acm(ACM,SRC, ["A","B.1.C", "D.F"]) -> {A:3, B{1:{C:4},D:{F:33.2}}}
        /**
         * 
         * @param {Object} acm 
         * @param {Collection} src 
         * @param {String | Array} keys 
         * @returns 
         */
        value: function (acm, src, keys = []) {
            if (Array.isArray(src)) {
                // Check if it's an array of objects/arrays, not primitives
                if (typeof src[0] === "object" && src[0] !== null) {
                    src.forEach((item) => Math.acm(acm, item, keys));
                    return acm;
                }
            }
            const A = Array.isArray(keys) ? keys : keys === "*" ? Object.keys(src) : [keys];
            A.forEach((key) => {
                acm.pointer(key, Math.sum(acm.pointer(key), src.pointer(key)));
            });
            return acm
        }
    },

    acms: { // accumulate_substract  -- revesul lui acm 
        value: function (acm, src, keys = []) {
            if (Array.isArray(src)) {
                // Check if it's an array of objects/arrays, not primitives
                if (typeof src[0] === "object" && src[0] !== null) {
                    src.forEach((item) => Math.acmd(acm, item, keys));
                    return acm;
                }
            }
            const A = Array.isArray(keys) ? keys : keys === "*" ? Object.keys(src) : [keys];
            A.forEach((key) => {
                acm.pointer(key, Math.diff(acm.pointer(key), src.pointer(key)));
            });
            return acm
        }
    },
    acmm: { // accumulate multiply
        value: function (acm, src, keys = []) {
            if (Array.isArray(src)) {
                // Handle array of objects/arrays
                if (typeof src[0] === "object" && src[0] !== null) {
                    src.forEach((item) => Math.acmm(acm, item, keys));
                    return acm;
                }
            }

            const A = Array.isArray(keys)
                ? keys
                : keys === "*"
                    ? Object.keys(src)
                    : [keys];

            A.forEach((key) => {
                const current = acm.pointer(key) || 1;
                const factor = src.pointer(key);
                if (typeof factor === "number") {
                    acm.pointer(key, current * factor);
                }
            });

            return acm;
        }
    },
    acmd: {// accumulate division 
        /* EX
        let acm = { a: 100, b: { x: 50 } };
        let src = { a: 2, b: { x: 5 } };
        Math.acmd(acm, src, ["a", "b.x"]);
        console.log(acm); // { a: 50, b: { x: 10 } }
        */
        value: function (acm, src, keys = []) {
            if (Array.isArray(src)) {
                if (typeof src[0] === "object" && src[0] !== null) {
                    src.forEach((item) => Math.acmd(acm, item, keys));
                    return acm;
                }
            }

            const A = Array.isArray(keys)
                ? keys
                : keys === "*"
                    ? Object.keys(src)
                    : [keys];

            A.forEach((key) => {
                const numerator = acm.pointer(key);
                const denominator = src.pointer(key);

                if (typeof numerator === "number" && typeof denominator === "number" && denominator !== 0) {
                    acm.pointer(key, numerator / denominator);
                }
            });

            return acm;
        }
    },
    agg: { // adunare pointer din colectie 
        value: function (col, key) { // col poate fi array-of-objects [{},{},...] sau object-of-objects {1:{},3:{},...}
            let r = 0;
            col.scan((k, v) => {
                r = Math.sum(r, v.pointer(key) ?? 0);
            });
            return r
        }
    },
    float0: {
        value: function (x) {
            // "-23,000.45" => -23000.45
            return parseFloat(typeof x === "string" ? x.replace(/,/g, "") : x) || 0;
        },
    },
    rad2deg: {
        value: function (rad) {
            return (rad * 180) / Math.PI;
        },
    },
    deg2rad: {
        value: function (deg) {
            return (deg * Math.PI) / 180;
        },
    },
    bytes: {
        value: function (x) {
            let l = 0,
                n = parseInt(x, 10) || 0;
            while (n >= 1024 && ++l) {
                n = n / 1024;
            }
            return n.toFixed(n < 10 && l > 0 ? 1 : 0) + " " + byte_units[l];
        },
    },
});
const byte_units = ["b", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

twoDigits = function (value) {
    let v = +value
    return v < 10 ? "0" + v : v;
};
function sign(x) {
    return x ? (x < 0 ? -1 : 1) : 0;
}

Object.defineProperties(Date.prototype, {
    date: {
        get: function () {
            //return this.toISOString().split('T')[0];

            var yyyy = this.getFullYear().toString();
            var mm = (this.getMonth() + 1).toString(); // getMonth() is zero-based
            var dd = this.getDate().toString();
            return yyyy + "-" + (mm[1] ? mm : "0" + mm[0]) + "-" + (dd[1] ? dd : "0" + dd[0]); // padding
        },
    },
    days_to: {
        value: function (date) {
            var days = (date - this) / (1000 * 60 * 60 * 24);
            return parseInt(days);
        },
    },
    time: {
        get: function () {
            return this.toTimeString().match(/\d{2}:\d{2}:\d{2}/)[0];
        },
    },
    datetime: {
        get: function () {
            return this.date + " " + this.time;
        },
    },
    monthLength: {
        get: function () {
            return new Date(this.getFullYear(), this.getMonth() + 1, 0).getDate();
        },
    },
    monthName: {
        get: function () {
            return this.monthNames[this.getMonth()];
        },
    },
    dayName: {
        get: function () {
            return this.dayNames[this.getDay()];
        },
    },
    yy: {
        get: function () {
            return this.getFullYear();
        },
    },
    mm: {
        get: function () {
            return this.getMonth();
        },
    },
    dd: {
        get: function () {
            return this.getDate();
        },
    },
    jump: { // n days 
        value: function (n) {
            this.setDate(this.getDate() + n);
            return this;
        },
    },
    offset: {
        /// ???? NU MERGE
        value: function (n) {
            var v = new Date();
            v.setDate(this.getDate() + n);
            return v;
        },
    },
    nwd: { // intoarce data de dupa n zile lucratoare
        value: function (n = 0) {
            if (!n || n <= 0) {
                return this.date;
            }
            this.jump(1);
            if (!this.free) {
                --n;
            }
            return this.nwd(n);
        }
    },
    free: {
        get: function () {
            return free_days.has(this.date) || [0, 6].has(this.getDay());
        }
    },
    addMonth: {
        value: function (n) {
            this.setMonth(this.getMonth() + n);
            return this;
        }
    },
    edgeMonth: {
        value: function (n) {
            var d;
            if (n > 0) {
                d = new Date(this.getFullYear(), this.getMonth() + 1, 0);
                this.setDate(d.getDate());
            } else {
                this.setDate(1);
            }
            return this;
        }
    }
});

Date.fix = function (str) {
    var d = new Date(str);
    return d.date;
};
Date.convert = function (str, format) {
    str += ""; // convert int to string
    switch (format) {
        case "d.m.Y H:i:s":
            var A = str.trim().split(/[\s,T]+/),
                B = A[0].split(".").reverse();
            return B.join("-") + " " + A[1]
        case "d.m.Y":
            var A = str.trim().split(/\s+/),
                B = A[0].split(".").reverse();
            return B.join("-");
        case "d-m-Y":
            var A = str.split('-').trim(),
                B = A.reverse();
            return B.join("-");

        default:
            let cnv;
            for (let f of ["d.m.Y H:i:s", "d.m.Y", "d-m-Y"]) {
                cnv = Date.convert(str, f);
                let D = new Date(cnv);
                if (D != "Invalid Date") {
                    return f == "d.m.Y H:i:s" ? D.datetime : D.date;
                }
            }
            // timestamp
            if (parseInt(str)) {
                let D = new Date(parseInt(str));
                if (D != "Invalid Date") {
                    return D.date
                }
            }
            break;
    }
    return false;
}
Date.min = function (a, b) {
    if (!a || !b) {
        return "1970";
    }
    return a < b ? a : b;
};
Date.max = function (a, b) {
    if (!a || !b) {
        return "1970";
    }
    return a > b ? a : b;
};
Date.days_between = function (a, b) {
    return Math.abs(new Date(a).days_to(new Date(b)));
};

Date.wd_between = function (a, b) { // [] interval inchis -- adica si capetele 
    let ds = new Date(a), df = new Date(b), N = 0;
    if (df < ds) {
        return 0;
    }
    if (!(ds < df) && !(ds > df)) { // ==
        return ds.free ? 0 : 1;
    }
    do {
        !ds.free && N++
        ds.jump(1);
    } while (ds < df);
    return N;
}

Date.monthsDiff = function (dS, dE) {
    var months;
    months = (dE.getFullYear() - dS.getFullYear()) * 12;
    months -= dS.getMonth();
    months += dE.getMonth();
    return months <= 0 ? 0 : months;
};
Date.diff = function (a, b) {
    return Date.dateDiff(new Date(a), new Date(b));
}
Date.dateDiff = function (dt1, dt2) {
    var ret = { days: 0, months: 0, years: 0 };
    if (dt1 === dt2) {
        return ret;
    }
    if (dt1 > dt2) {
        var dtmp = dt2;
        dt2 = dt1;
        dt1 = dtmp;
    }
    var year1 = dt1.getFullYear();
    var year2 = dt2.getFullYear();
    var month1 = dt1.getMonth();
    var month2 = dt2.getMonth();
    var day1 = dt1.getDate();
    var day2 = dt2.getDate();
    ret["years"] = year2 - year1;
    ret["months"] = month2 - month1;
    ret["days"] = day2 - day1;
    if (ret["days"] < 0) {
        var dtmp1 = new Date(dt1.getFullYear(), dt1.getMonth() + 1, 1, 0, 0, -1);
        var numDays = dtmp1.getDate();
        ret["months"] -= 1;
        ret["days"] += numDays;
    }
    if (ret["months"] < 0) {
        ret["months"] += 12;
        ret["years"] -= 1;
    }
    return ret;
};

Date.prototype.monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
Date.prototype.dayNames = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];



function Timer(fn, dur) {
    var $ = this;
    $.fn = fn;
    $.run = function () {
        if ($.interval) return;
        fn();
        $.interval = setInterval($.fn, $.dur);
    };
    $.stop = function () {
        clearInterval($.interval);
        $.interval = null;
    };
    $.trig(
        "dur",
        function (x) {
            $.stop();
            $.run();
        },
        dur || 500
    );
}

Q.repeat = function (what, intv, N) {
    //
    N = N || 1;
    what();
    if (--N) {
        var si = setInterval(function () {
            --N;
            if (N < 0) {
                clearInterval(si);
                return;
            }
            what();
        }, intv);
    }
};

//function key(e){return e.witch||e.keyCode}
function ifnull(a, b) {
    return Q.bool(a) ? a : b;
}



/**
 *  // !!!BAC>>>  e pest Obj.tail(Obj) pentru
 * ex class C1 {
 *  mtd_1()=>{}
 * }
 * 
 * ObjSource = {
 *      abc:1,
 *      get caca (){ // getter
 *              ...
 *       },
 *       func1(a,b){ ... },
 *       func2:function(){ ... },
 *       // nu arrow function pt ca ignora  .bind(smth) la utilizare
 *       f_gresit: ()=>{ }   
 * }
 * 
 *  C1.prototype.__extend__(ObjSource)
 * 
 * // !!!BAC>>>   ATENTIE -- nu folosi arrow funntion in Obiectul Sursa -- se pierde this 
 */
Object.defineProperty(Object.prototype, "__extend__", {
    value: function (OS) {
        Object.defineProperties(this, Object.getOwnPropertyDescriptors(OS))
    }
})



class Mapo extends Map {

    constructor(data, ...args) {
        if (data && typeof data === 'object' && !Array.isArray(data) && !(data instanceof Map)) {
            super(...args);
            for (const k of Object.keys(data)) {
                const num = Number(k);
                const key = (!Number.isNaN(num) && String(num) === k) ? num : k;
                this.set(key, data[k]);
            }
        } else {
            super(data, ...args);
        }

        return new Proxy(this, {

            get(target, prop, receiver) {
                if (prop in target) {
                    const val = Reflect.get(target, prop, target);
                    return typeof val === 'function' ? val.bind(target) : val;
                }
                const key = Mapo._canonicalKey(target, prop);
                if (target.has(key)) return target.get(key);
                return undefined;
            },

            set(target, prop, value) {
                if (prop in target) return Reflect.set(target, prop, value);
                target.set(Mapo._canonicalKey(target, prop), value);
                return true;
            },

            has(target, prop) {
                return target.has(Mapo._canonicalKey(target, prop));
            },

            ownKeys(target) {
                return [...target.keys()].map(String);
            },

            getOwnPropertyDescriptor(target, prop) {
                const key = Mapo._canonicalKey(target, prop);
                if (target.has(key)) {
                    return { value: target.get(key), enumerable: true, configurable: true, writable: true };
                }
                return undefined;
            },

            deleteProperty(target, prop) {
                if (prop in target) return Reflect.deleteProperty(target, prop);
                const key = Mapo._canonicalKey(target, prop);
                return target.has(key) ? target.delete(key) : true;
            }
        });
    }

    static _canonicalKey(target, prop) {
        if (target.has(prop)) return prop;
        if (typeof prop === 'string') {
            const num = Number(prop);
            if (!Number.isNaN(num) && target.has(num)) return num;
            if (!Number.isNaN(num) && String(num) === prop) return num;
        }
        return prop;
    }

    hasOwnProperty(key) { return this.has(key); }

    scan(cb) {
        let idx = 0;
        const res = [];
        for (const [k, v] of this) res.push(cb.call(this, k, v, idx++));
        return res;
    }

    first() {
        const it = this.values().next();
        return it.done ? null : it.value;
    }

    toObject() {
        const o = {};
        for (const [k, v] of this) o[k] = v;
        return o;
    }
}


function isTraversable(val) {
    if (val === null) return false;
    if (typeof val !== 'object') return false;
    // filter out boxed primitives like String, Number, Boolean
    const protoTag = Object.prototype.toString.call(val);
    return !['[object String]', '[object Number]', '[object Boolean]'].includes(protoTag);
}


// diff -e sters ca e o porcarie

Object.defineProperty(Object.prototype, "alike", {
    // same structure and same values but not identicall   o1={...o2}
    value: function (O, ignore = []) {
        var $ = this,
            A = true,
            N = 0;
        for (let set of [  // toate proprietatile din A  se regasesc in  B si invers tot din B este in A 
            [$, O],
            [O, $],
        ]) {
            if (!A) {
                break;
            } //  daca la comparatia directa [$,O] am false nu mai fac reverse 
            (function foo(a, b) {
                if (!b) {
                    A = false;
                    return;
                }
                if (isTraversable(a)) {
                    for (var i in a) {
                        if (ignore.includes(i)) {
                            continue;
                        }
                        if (typeof a[i] === "object") {
                            if (a[i] == b[i]) {
                                // null is object
                                continue;
                            } else {
                                foo(a[i], b[i]);
                            }
                        } else {
                            if (a[i] != b[i]) {
                                A = false;
                                break;
                            }
                        }
                        if (!A) {
                            break;
                        }
                    }
                }
                else {
                    A = !!(a == b);
                }
            })(...set);
        }
        return A;
    },
});


// compare collections [{},{}]
Object.defineProperty(Array.prototype, "alike", {
    value: function (S, ignore = []) {
        let $ = this;
        if (!Array.isArray(S) || S.length != $.length) return false;
        let B = [...S];
        for (let e of $) {

            // exista un obiect alike in B
            let found_e = false;
            for (let i in B) {
                if (B[i].alike(e, ignore)) {
                    B.splice(i, 1); // elimin elementul gasit 
                    found_e = true;
                    break;
                }
            }
            if (!found_e) {
                return false
            } // la primul element not alike intregu nu mai e ok
        }
        return true
    }
})


Object.defineProperties(HTMLFormElement.prototype, {
    clear: {
        value: function () {
            this.find("[name]").map((e) => {
                e.value = "";
                delete e.real_value;
                delete e.old_real_value;
            });
            return this;
        },
    },
    inputs: {
        get: function () {
            return this.find("[name]");
        }
    },
    readonly: {
        get: function () {
            return this._readonly_ || false;
        },
        set: function (x) {
            if (x) {
                this._readonly_ = true;
                if (!this.hasOwnProperty("_old_state_")) {
                    this._old_state_ = {};
                }
                this.find("[name]").map((e) => {
                    this._old_state_[e.name] = e.getA("readonly");
                    e.setA("readonly");
                });
            } else {
                if (this._old_state_) {
                    this.find("[name]").map((e) => {
                        this._old_state_[e.name] ? e.setA("readonly") : e.remA("readonly");
                    });
                }
            }
        },
    },
    data: {
        get: function () {
            let o = {};
            [...this.inputs].map(i => {
                o[i.name] = i.value
            });
            return o;
        },
        set: function (o) {
            let $ = this;
            o.scan((k, v) => {
                if ($[k]) {
                    $[k].value = v;
                }
            });
        }
    },
    populate: { // !!!BAC>>> template strict logic 
        /**
         * Usage examples:
         *
         * 1) Minimal: rely on form context/template
         *    form.tb_name = 'users';
         *    form.template = TE;
         *    form.populate();
         *
         * 2) Explicit: pass all sources directly
         *    form.populate({
         *      tb_name: 'users',
         *      template: TE,
         *      tdf: TE.tdf.users,
         *      rules: TE.conf.rules?.users || {},
         *      data: { name: 'John', email: 'john@example.com' },
         *      hide: ['id', 'password']
         *    });
         */
        value: function (o = {}) {
            var $ = this;

            // Resolve active table target context safely
            var tb_name = o.tb_name ?? $.tb_name;
            if (!tb_name) {
                throw new Error(`tb_name required !!!!  
                form.populate({tb_name:'ex_grid_q'}) 
                // or  
                form.tb_name=' ... ';  form.populate({})
                `);
            }


            // Extract variables with fallback logic
            var template = o.template ?? $.template ?? {},
                tdf = o.tdf ?? template.tdf?.[tb_name] ?? {},
                rules = o.rules ?? template.conf?.rules?.[tb_name] ?? {},
                columns = o.columns ?? rules.columns ?? Object.keys(tdf),
                hide = o.hide ?? rules.hide ?? [],
                data = o.data // always explicit 
            // --?? template.data?.[tb_name]?.[0]; // can pas data as object or fallback to teplate.data which is array

            // Normalize hide filters list safely
            hide = ['id', ...(Array.isArray(hide) ? hide : [hide])];

            // Filter out hidden columns from the final render list
            columns = columns.filter(c => !hide.includes(c));

            // Dynamic Hydration: Map flat index streams to structured keys
            if (Array.isArray(data)) {
                data = [].combine(Object.keys(tdf), data); // object again from array based schema columns
            } else {
                data = data || {}; // Prevents data[col] from crashing on empty states
            }

            $.tb_name = tb_name; // Ensure form context is set for downstream operations
            $.setA("logical_row");

            o.template ??= template;
            o.tdf = tdf;

            $.innerHTML = '';

            columns.map(c_name => {
                var current_value = data[c_name] ?? tdf[c_name]?.dft ?? "";

                // Generate the specialized framework input natively via Q.gnr_input
                var new_inp = Q.gnr_input(current_value, c_name, o);

                // Build layout wrapper matching your framework schema specifications
                var wrap = _E("<div wrap c_name='" + c_name + "'></div>");
                var label = _E("span");

                // alias masking column real name
                label.html = rules.alias?.[c_name] ?? tdf[c_name]?.cmt?.label ?? c_name;
                wrap._(new_inp.piker, new_inp, _E(), label);

                $._(wrap);

                if (new_inp.cdf?.cmt?.mask && typeof jQuery !== 'undefined') {
                    jQuery(new_inp).inputmask(new_inp.cdf.cmt.mask);
                }

                if (typeof edit_switch !== 'undefined' && !edit_switch.active) {
                    new_inp.setA("disabled");
                }
            });

        }
    }
});





function aha_print(OPT) {
    var printer = OPT.use_printer || "/~/printer/printer.php";
    if (OPT.ext) {
        switch (OPT.ext) {
            case "xlsx":
            case "xls":
                printer = "/~/printer_xlsx.php"
                break;
            case "pdf":
                printer = "/~/printer_pdf.php"
                break;
            case "docx":
            case "doc":
                printer = "/~/printer/printer.php"
                break;
        }
    }
    var POST = new FormData;
    POST.load(OPT);
    console.log(OPT);
    let LOADER = generate_loader({ loader: "circle" });
    fetch(printer, {
        method: "POST",
        body: POST
    })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            var error = response.headers.get('error');
            if (error) {
                throw new Error(`${error}`);
            }

            let filename = 'downloaded-file'; // Default filename
            const disposition = response.headers.get('Content-Disposition');
            if (disposition && disposition.includes('filename=')) {
                const filenameMatch = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                if (filenameMatch) {
                    filename = filenameMatch[1].replace(/['"]/g, ''); // Remove quotes if present
                }
            }
            filename = OPT.save_as || filename;
            LOADER.die();
            return response.blob().then(blob => ({ blob, filename }));
        })
        .then(({ blob, filename }) => {
            // Create a temporary URL for the blob
            const blobUrl = URL.createObjectURL(blob);
            // Create a temporary anchor element
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = filename; // Use the filename from the server
            document.body.appendChild(a); // Add the anchor to the DOM
            a.click(); // Programmatically click the anchor to trigger the download
            a.remove(); // Remove the anchor from the DOM
            // Revoke the blob URL to free up memory
            URL.revokeObjectURL(blobUrl);
        })
        .catch(error => {
            LOADER.die();
            dn(error.message, "ERROR");
        });
}






aha_zip = function (opt) {
    opt.use_printer = "/zipper.php";
    aha_print(opt);
};

aha_get_excell = function (opt) {
    opt.use_printer = "/exceller.php";
    aha_print(opt);
};

Object.defineProperties(HTMLTableElement.prototype, {
    xls: { // converteste html-table to excell direct in client
        value: function (o) {
            var $ = this,
                o = o || {},
                out = "<table border='2px'><tr bgcolor='#BBDDFF'>";
            for (var j = 0; j < $.rows.length; j++) {
                out += $.rows[j].innerHTML + "</tr>";
            }
            out += "</table>";
            if (o.clear) {
                out = out.replace(/<A[^>]*>|<\/A>/g, ""); //remove if u want links in your table
                out = out.replace(/<img[^>]*>/gi, ""); // remove if u want images in your table
                out = out.replace(/<input[^>]*>|<\/input>/gi, ""); // reomves input params
            }
            var a = _E("a");
            a.download = o.save_as || "download.xls";
            a.href = window.URL.createObjectURL(new Blob([out], { type: "text/xls;charset=UTF-8" }));
            window.document.body._(a);
            a.click();
            a.die();
            URL.revokeObjectURL(a.href);
        },
    },


    scroll_size: {
        get: function () {
            return this.parent.getA("scroll_size");
        },
        set: function (val) {
            if (val) {
                this.parent.setAttribute("scroll_size", val);
                this.parent.css("max-height:" + val + "px");
                this.setA("sticky_head");
            } else {
                this.parent.remA("scroll_size");
                this.parent.css("max-height:initial");
                this.remA("sticky_head");
            }
        },
        enumerable: true
    },
});

Q.cookie = {
    set: function (cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    get: function (name) {
        var reg = new RegExp(name + "=[^;]*", "gim");
        var rez = reg.exec(document.cookie);
        return rez ? rez[0].split("=")[1] : false;
    },
    delete: function (x) {
        document.cookie = x + "=''; expires=Thu, 01 Jan 1970 00:00:00 GMT;";
    },
    all: function () {
        return (all = document.cookie.split(";").trim() || "");
    },
    clear: function () {
        var all = Q.cookie.all();
        all.map(function (item) {
            var tmp = item.split("=");
            Q.cookie.delete(tmp[0]);
        });
    },
};



Object.defineProperty(window, "xdebug", {
    get: function () {
        let c = Q.cookie.get("XDEBUG_TRIGGER");
        return c ? ("ON :" + c) : "OFF";
    },
    set: function (v) {
        let c = Q.cookie.get("XDEBUG_TRIGGER");
        if (v) {
            if (c) {
                console.log("XDEBUG este deja activat pe portul " + c);
                return;
            }
            let X = Q.cookie.all().filter(a => { return /XDEBUG_TRIGGER/.test(a) })[0];
            if (X) {
                let a = X.split("="), name = a[0], port = parseInt(a[1]);
                if (port) {
                    Q.cookie.set("XDEBUG_TRIGGER", port);
                    Q.cookie.delete(name);
                }
                else {
                    console.log("Trebuie sa definesti in Application/Cookies  XDEBUG_TRIGGER = 90xx \n portul poate fi [9010..9019] dar atentie la conflictul cu alt developer")
                }
            } else {
                Q.cookie.set("XDEBUG_TRIGGER", 0);
            }
        } else {
            if (c) {
                Q.cookie.set("XDEBUG_TRIGGER_OFF", c);
                Q.cookie.delete("XDEBUG_TRIGGER");
            }
        }
    },
    enumerable: true,
});

Object.defineProperty(Q, "redis_off", {
    get: function () {
        return Q.cookie.get("REDIS_OFF");
    },
    set: function (v) {
        if (v) {
            Q.cookie.set("REDIS_OFF", true);
        } else {
            Q.cookie.delete("REDIS_OFF");
        }
    },
    enumerable: true,
});

Object.defineProperty(Q, "livereload", {
    get: function () {
        return localStorage.livereload;
    },
    set: function (v) {
        if (v) {
            localStorage.livereload = 1;
        } else {
            localStorage.removeItem("livereload");
        }
    },
    enumerable: true,
});

Object.defineProperty(Q, "ajax_timeout", {
    get: function () {
        return localStorage.ajax_timeout;
    },
    set: function (v) {
        if (Number.isFinite(v)) {
            localStorage.ajax_timeout = v;
        } else {
            localStorage.removeItem("ajax_timeout");
        }
    },
    enumerable: true,
});



// NEURON

var all_neurons_number = 0;
// ex n0=new Neuron;n1=new Neuron;n0.link(n1);n1.link(n2 = new Neuron({caca:1}));n1.link(n3 = new Neuron());n2.link(n4 = new Neuron);
// n2.conf={A:1};n4.conf={A:1}
function Neuron(o = {}) {
    var $ = this;
    $.tail(o);
    $.name = o.name || "neuron_" + all_neurons_number++;
    $.axon = null; // noteaza neuronul parinte
    $.conf = {};
    $.paths = {};
    $.on = {};
    $.length = 0; // numarul de descendenti
    $.dendrites = {};
}

Neuron.prototype = {
    speed: {
        fast: 1,
        slow: 100,
        lasy: 1000,
    },
};

Object.defineProperties(Neuron.prototype, {
    toString: {
        value: function () {
            return "Neuron";
        },
    },
    link: {
        value: function (neuron) {
            this.dendrites[neuron.name] = neuron;
            ++this.length;
            neuron.axon = this;
            return this;
        },
    },
    unlink: {
        value: function (neuron) {
            this.dendrites.drop([neuron.name]);
            --this.length;
            return neuron;
        },
    },
    pong: {
        value: function (o) {
            // trimitere semnal catre parinte prin axon
            o = o || {};
            if (!o.path) {
                o.path = [];
            }
            o.path.unshift(this); // PATH --- arata de unde vine PONG-ul
            this.axon && wait(this.delay(o)).then(() => this.axon.feel_pong(this, o));
            return this;
        },
    },
    feel_pong: {
        value: function (emiter_neuron, o = {}) {
            // receptararea un unui semnal prin dendrita  de la copil
            o.do && o.do.bind(this)(o);
            this.react_on("pong", o);
            o.complete && this.check_completion(emiter_neuron); // !!! BAC >>> COMPLETE is a special signal that propagates up conditionally
            o.event && this.react_on(o.event.type, o.event);
            !o.halt && !o.stop && this.pong(o); // propagate upword default yes
            return this;
        },
    },
    ping: {
        value: function (neuron, o) {
            // trimiterea unui semnal prin dendrita
            wait(this.delay(o)).then(() => neuron.feel_ping(o));
            return this;
        },
    },
    feel_ping: {
        value: function (o) {
            // primire semnal prin axon de la parinte
            o.do && o.do.bind(this)(o);
            this.react_on("ping");
            o.event && this.react_on(o.event.type, o.event);
            return this;
        },
    },
    propagate: {
        value: function (signal, o, depth = 1) {
            var D = this.dendrites,
                o = o || {};
            if (o.limit && depth > o.limit) {
                return;
            }
            switch (signal) {
                case "ping": // n1.propagate("ping",{limit:1})
                    for (var n in D) {
                        if (o.having) {
                            var c = D[n].conf;
                            var ok = true;
                            for (var p in o.having) {
                                // condition to propagate downword
                                if (o.having[p] !== c[p]) ok = false;
                            }
                            if (ok) {
                                this.ping(D[n]);
                                D[n].propagate(signal, o, ++depth);
                            }
                        } else {
                            this.ping(D[n], o);
                            D[n].propagate(signal, o, ++depth);
                        }
                    }
                    break;
                case "pong": // PROPAGATE UPWORD
                    if (!o.path) {
                        o.path = [];
                    }
                    o.path.unshift(this);
                    this.axon && this.pong(o) && this.axon.propagate(signal, o, ++depth);
                    break;
                // DOWNWORD PROPAGATION WITH CONFIG UPDATE
                // Examples:
                // 1) n0.propagate("conf", { data:[1,2,3], A:1 })
                //    -> each child gets child.conf.data and child.conf.A updated.
                // 2) n0.propagate("#completion", { ok:true })
                //    -> each child runs child.run("completion", { ok:true }).
                // 3) TE.neuron.propagate('on', {"foo": function () { Q.i(this); }}, 0)
                //    -> attach runtime handler this.on.foo on self and descendants.
                // 4) TE.neuron.propagate('#foo', {}, 0)
                //    -> execute foo handler on self and descendants via run("foo", {}).
                default:
                    if (depth == 0) { // self apply 
                        if (/^#/.test(signal)) {
                            this.run(signal.replace(/^#/, ''), o);
                        }
                        else {
                            for (var p in o) {
                                if (!this[signal]) {
                                    this[signal] = {}
                                }
                                this[signal][p] = o[p];
                            }
                        }
                    }
                    for (var n in D) {
                        if (/^#/.test(signal)) {
                            D[n].run(signal.replace(/^#/, ''), o);
                        }
                        else {
                            for (var p in o) {
                                if (!D[n][signal]) {
                                    D[n][signal] = {}
                                }
                                //D[n].pointer([signal, p], o[p]); // pointer logic omoara functiile 
                                D[n][signal][p] = o[p];
                            }
                        }
                        D[n].propagate(signal, o, depth + 1);
                    }
                    break;
            }
            return o;
        },
    },
    find: {
        value: function () { },
    },
    check_completion: {
        value: function (neuron) {
            var $ = this;
            if (!this.completion) {
                this.completion = [];
            }
            this.completion.push(neuron.name);
            for (var n in this.dendrites) {
                if (!this.completion.has(n)) {
                    return; // daca nu am primit complition /pong de la toti descendentii astept in continuare
                }
            }
            this.react_on("completion");
            this.completion = [];
            $.pong({ complete: true });
        },
    },
    flood: {
        value: function (o) {
            this.propagate("ping", o, 1);
        },
    },
    react_on: {
        // normalizeaza  reactiile adica ma lasa  sa  fac neuron_x.on.pong = f1 or {a:f1,b:f2} or [f1,f2]
        value: function (signal, o = {}) {
            var hnd = this.on[signal] || [];
            hnd = typeof hnd === "object" ? hnd : [hnd];
            for (let i in hnd) {
                hnd[i].bind(this)(o);
            }
        },
    },
    run: {
        value: function (signal, o = {}, propagate = false) {
            this.react_on(signal, o);
            return this;
        }
    },
    delay: {
        value: function (o = {}) {
            var d = 5;
            switch (o.speed) {
                case "lasy":
                    d = 1000;
                    break;
                case "fast":
                    d = 1;
                    break;
                case "slow":
                    d = 100;
                    break;
                default:
                    if (+o.speed) {
                        d = o.speed;
                    }
                    break;
            }
            return d;
        },
    },
});

// WORKER -- MAIN SIDE
/**
 *  as se vedea worker.js 
 
 * @param {type} obj * @return {Worker.prototype} */

Object.defineProperties(Worker.prototype, {
    run: {
        value: function (obj) {
            if (obj.cmd) {
                this.postMessage({ cmd: obj.cmd, data: obj.data });
            } else {
                this.postMessage({ cmd: "run", data: obj || {} });
            }
            return this;
        },
    },
    lunch: function (obj) {
        // {cmd:"",data:"",cb:''}
    },
});

Worker.prototype.store = function (obj) {
    this.postMessage({ cmd: "store", data: obj || {} });
};
Worker.prototype.clear = function () {
    this.postMessage({ cmd: "clear" });
};
Worker.prototype.log = function (key) {
    this.postMessage({ cmd: "log", key: key });
};
/**
 * Implemantare WORKER
 
 * @param {type} source
 * @param {type} cb_default
 * @param {type} on_error
 * @returns {thread.W|Worker} */
allWorkers = {};

thread = function (source, cb_default, on_error) {
    var W = new Worker(source);
    allWorkers[source] = W;
    W.source = source;
    W.default = cb_default || nf;
    on_error && (W.onerror = on_error);
    W.onmessage = function (ev) {
        if (ev.data && ev.data.cmd) {
            var D = ev.data;
            switch (D.cmd) {
                case "dn":
                    dn(D.data, "Worker : " + (W.title || ""));
                    break;
                case "inspect":
                    Q.i(D.data, { title: W.source });
                    break;
                default:
                    try {
                        if (D.cmd) {
                            W[D.cmd](D.data, D.opt);
                        } else {
                            throw source;
                        }
                    } catch (e) {
                        throw 'WORKER "' + source + '" REQUIRES "' + D.cmd + '" to be defined in THREAD';
                    }
            }
        } else {
            W.default(ev.data);
        }
    };
    return W;
};


window.gren2red_prc = (prc) => {
    var hue = (120 - (prc / 100) * 120).toFixed(2);
    return ["hsl(", hue, ",100%,40%)"].join("");
}


// php like functions
JSON.decode = JSON.parse;
JSON.encode = JSON.stringify;



/**
 * Hash-uiește un File/Blob în browser.
 * @param {File|Blob} file - obiectul File sau Blob
 * @param {string} [algorithm='SHA-256'] - 'SHA-1' | 'SHA-256' | 'SHA-384' | 'SHA-512'
 * @param {'hex'|'base64'|'bytes'} [output='hex'] - formatul rezultatului
 * @returns {Promise<string|Uint8Array>} - hash în formatul ales
 */
async function getFileHash(file, algorithm, output = "hex") {
    // citește conținutul ca ArrayBuffer
    const buffer = await file.arrayBuffer();
    // calculează digestul
    const digest = await crypto.subtle.digest(algorithm || "SHA-256", buffer);
    const bytes = new Uint8Array(digest);
    if (output === "bytes") return bytes;
    // helper hex
    if (output === "hex") {
        return Array.from(bytes)
            .map((b) => b.toString(16).padStart(2, "0"))
            .join("");
    }
    // helper base64 (într-un mod sigur pentru buffer mare)
    if (output === "base64") {
        // convertim pe blocuri pentru a evita probleme cu apply/btoa la array foarte mare
        let chunkSize = 0x8000;
        let str = "";
        for (let i = 0; i < bytes.length; i += chunkSize) {
            const slice = bytes.subarray(i, i + chunkSize);
            str += String.fromCharCode.apply(null, slice);
        }
        return btoa(str);
    }
    throw new Error('Output format invalid: use "hex", "base64" or "bytes"');
}
window.File.prototype.hash = async function (algorithm = 'SHA-256', output = 'hex') {
    return await getFileHash(this, algorithm, output);
}




function alphaLabel(n) {
    n = Number(n);

    if (!Number.isInteger(n) || n < 0) {
        throw new Error("Invalid index");
    }

    let s = "";

    do {
        s = String.fromCharCode(65 + (n % 26)) + s;
        n = Math.floor(n / 26) - 1;
    }
    while (n >= 0);

    return s;
}